import { Observable, BehaviorSubject, ObservableInput, throwError, from, of, forkJoin, firstValueFrom } from 'rxjs';
import { computed, inject, Injectable, DOCUMENT, resource, ResourceRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, httpResource } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { map, catchError, tap, switchMap } from 'rxjs/operators';
import {
  Gruppe,
  Firma,
  KundenPrüfungTypen,
  MRproResponse,
  MRproResponseInfo,
  Media,
  NewAuftragModel,
  SpezResponse,
  StammAuswahl,
  StammDatenResponse,
  SaveSpezifikationModel,
} from 'src/app/types/api';
import { FremdleistungUpdateInput, FremdleistungInput } from 'src/app/types/fremdleistung';
import { AppDB, IsRep, KINTERF, SYSINI, SYSOOPT } from '../_offline/dexieDB';
import { SOTYP, SOTYP_Map } from 'src/app/models/api/SOTYP';
import { Row, Table } from 'src/app/models/ui/table';
import { HistorieNode } from 'src/app/content/_components/detailview/historie-tree/historie-tree.component';
import { ReplikatSetup, ReplikatSyncBack, SetupConfig } from '../_offline/rep-setup.service';
import { AnlagenDB } from '../_offline/anlagenDB';
import { DetailViewResponse } from 'src/app/content/_components/detailview/detailview.types';
import { MangelDB } from '../_offline/mangelDB';
import { LogEintrag } from 'src/app/content/_components/detailview/mangel-log-modal/mangel-log-modal.component';
import { EinstellungenDB } from '../_offline/einstellungenDB';
import { StammDatenModel } from 'src/app/content/_components/_overlays/stammdatendialog/stammdatendialog.component';
import {
  SpezPointType,
  SpezColumnType,
  SpezRowType,
} from 'src/app/content/_components/_overlays/spezifikationsdialog/spezifikationsdialog.component';
import { FileForPreview } from 'src/app/content/_components/_shared/preview-thumbnails/preview-thumbnail.type';
import {
  MangelModel,
  MangelRowModel,
  MangelRowType,
  SpezRow,
} from 'src/app/content/_components/_overlays/mangelerfassungsdialog/mangel-erfassung.types';
import { FileObject } from '../base64/base64.service';
import {
  BauwerkeModel,
  BauwerkRow,
} from 'src/app/content/_components/_overlays/bauwerksdialog/bauwerksdialog.component';
import JSZip from 'jszip';
import { AuftragImportInfor } from 'src/app/content/Auftraege/newauftragmodal/newauftragmodal.component';
import { BaseItem } from 'src/app/content/_components/_modals/baseitems-wrapper/baseitems-wrapper.component';
import { User } from 'src/app/models/api/User';
import {
  NaturschutzModel,
  NaturschutzRow,
} from 'src/app/content/_components/_overlays/naturschutzdialog/naturschutzdialog.component';
import { HerstellDaten } from 'src/app/content/_components/detailview/herstell-daten-modal/herstell-daten-modal.component';
import { AlkisAPI } from 'src/app/types/alkis';
import { ObjektTypModel } from 'src/app/content/_components/_overlays/systemmanagementdialog/systemmanagementdialog.component';
import { ImportObjektTypTable } from 'src/app/content/_components/_overlays/objekttyp/objekttypdialog.component';
import {
  Bauform,
  BauformModel,
  Komponente,
  WerteListe,
} from 'src/app/content/_components/_overlays/bauform-verwaltung/bauform-verwaltung.component';
import { SWTYP_Item } from 'src/app/content/_components/_modals/baseitems-wrapper/baseitems-swtyp-modal/baseitems-swtyp-modal.component';
import { SSCHF_Item } from 'src/app/content/_components/_modals/baseitems-wrapper/baseitems-sschf-modal/baseitems-sschf-modal.component';
import { SBAGP_Item } from 'src/app/content/_components/_modals/baseitems-wrapper/baseitems-sbagp-modal/baseitems-sbagp-modal.component';
import { SBFEK_Item } from 'src/app/content/_components/_overlays/gleis-code-verwaltung/gleis-code-verwaltung.component';
import { SGATT_Item } from 'src/app/content/_components/_modals/baseitems-wrapper/baseitems-sgatt-modal/baseitems-sgatt-modal.component';
import { SBAUW_Item } from 'src/app/content/_components/_modals/baseitems-wrapper/baseitems-sbauw-modal/baseitems-sbauw-modal.component';
import {
  BUE_Map,
  BUE_Quadrant,
  QuadrantWert,
} from 'src/app/content/_components/_overlays/bahnuebergangsdialog/bahnuebergangsdialog.component';
import { CamImageResponse } from 'src/app/content/_components/detailview/streckenbilder/streckenbilder.component';
import { ProfileResponse, Profil } from 'src/app/content/_components/_overlays/profileviewer/profileviewer.component';
import {
  EreignisModel,
  EreignisRow,
} from 'src/app/content/_components/_overlays/ereignisdialog/ereignisdialog.component';
import {
  HelperTabelle,
  HilfeBeschreibung,
} from 'src/app/content/_components/_modals/hilfebeschreibungmodal/hilfebeschreibungmodal.component';
import {
  MangelBaumNode,
  MangelBaumNodeModel,
  BaumSelect,
  EMPTY_SELECT,
  BaumSelectUsed,
  EMPTY_USED_SELECT,
} from 'src/app/content/_components/_overlays/mangelbaum/mangelbaum.component';
import { BaseItemsDB } from '../_offline/baseitemsDB';
import { rxResource } from '@angular/core/rxjs-interop';
import { TABLE_EMPTY } from 'src/app/models/ui/table/table';
import { Position } from 'geojson';
import { MangelBaumDB } from '../_offline/mangelBaumDB';
import { UploadResult } from 'src/app/content/_components/_modals/messdaten-import/weichen-messdaten-import';
import { KTOLR } from '../_offline/zaehlerDB';
import { Key } from 'src/app/types/shared';
import {
  GIModel,
  GIRow,
} from 'src/app/content/_components/_overlays/grundinstandsetzungdialog/grundinstandsetzungdialog.component';
import {
  AbnahmeDetailResponse,
  AbnahmeMangel,
  AbnahmeProtokollSummary,
  AbnahmeSaveFilesRequest,
  AbnahmeSaveFilesResponse,
  AbnahmeSaveRequest,
  AbnahmeSaveResponse,
} from 'src/app/content/_components/_overlays/abnahme-protokoll/abnahme-protokoll.types';

export const API_URL = environment.apiUrl;

export interface ErrorPayload {
  message: string;
  stack?: string;
  timestamp: string;
  source?: string;
  phase?: string;
  errorCode?: string;
  email?: string;
  tenantId?: string;
  appId?: string;
  database?: string;
  metadata?: string;
}

export interface OktaLoginRequest {
  email: string;
  username: string;
  givenName: string;
  familyName: string;
  usergruppen: string[];
  oktaUserId?: string;
  database?: string;
}

export interface OktaDatabaseOption {
  name: string;
  label: string;
}

export interface OktaLoginResponse {
  success?: boolean;
  error?: string;
  traceId?: string;
  timestamp?: string;
  exceptionType?: string;
  validationError?: boolean;
  validationDetails?: Record<string, string[]>;
  token?: string;
  expiresAt?: string;
  refresh?: Record<string, string>;
  rights?: unknown;
  auftraglaenge?: string;
  optInterface?: string;
  hasMap?: boolean;
  db?: string;
  image?: string;
  twofa?: number;
  mfaaktiv?: boolean;
  usemsal?: boolean;
  /** Die Okta-Gruppen zeigen auf mehrere Datenbanken - der Login muss mit `database` wiederholt werden. */
  databaseSelectionRequired?: boolean;
  databases?: OktaDatabaseOption[];
}

@Injectable({
  providedIn: 'root',
})
export class APIService {
  private readonly db = inject(AppDB);
  private readonly http = inject(HttpClient);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly document = inject(DOCUMENT);
  private readonly einstellungenDB = inject(EinstellungenDB);
  private readonly mangelDB = inject(MangelDB);
  public readonly anlagenDB = inject(AnlagenDB);
  private readonly baseItemsDB = inject(BaseItemsDB);
  private readonly mangelBaumDB = inject(MangelBaumDB);

  private suppressLicenseRequests = false;
  public readonly AUTH = { Bearer: '' };

  public AUTH_HEADER: { headers: HttpHeaders; responseType: 'json' } = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, private',
    }),
    responseType: 'json',
  };

  public readonly AUTH_HEADER_LOGIN_NO_CACHE = {
    headers: new HttpHeaders({ 'Cache-Control': 'no-store, must-revalidate' }),
    responseType: 'json',
  } as const;

  public AUTH_HEADER_NO_CACHE: { headers: HttpHeaders; responseType: 'json' } = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-store, must-revalidate',
    }),
    responseType: 'json',
  };

  public AUTH_HEADER_BIN: { headers: HttpHeaders; responseType: 'blob' } = {
    headers: new HttpHeaders(),
    responseType: 'blob',
  };

  public AUTH_HEADER_ARR: {
    headers: HttpHeaders;
    responseType: 'arraybuffer';
  } = {
    headers: new HttpHeaders(),
    responseType: 'arraybuffer',
  };

  public AUTH_HEADER_OBSERVE: {
    headers: HttpHeaders;
    responseType: 'json';
    reportProgress: true;
    observe: 'events';
  } = {
    headers: new HttpHeaders({ 'ngsw-bypass': '' }),
    responseType: 'json',
    reportProgress: true,
    observe: 'events',
  };

  public isRep: boolean;
  public aud: string = '';
  public tid: string = '';

  private img_placeholder = new BehaviorSubject('https://via.placeholder.com/400x300');

  //#region all
  constructor() {
    this.refreshJWT();
  }

  public restPWUser(editarr: any) {
    return this.http.post(API_URL + '/login/resetrequiredpassword', editarr);
  }

  public updatepassword(email: string, userid: string, pw: string) {
    return this.http.post(API_URL + '/login/resetpassword', {
      email: email,
      id: userid,
      pw: pw,
      key: '9eec9eba-cb65-42c0-bff8-4dee0072ea4c',
    });
  }

  public getOktaMRproToken(oktaLoginRequest: OktaLoginRequest): Observable<OktaLoginResponse> {
    return this.http.post<OktaLoginResponse>(API_URL + '/login/testokta', oktaLoginRequest);
  }

  public sendforgotemail(email: string, codes: string) {
    // Updated to use new secure password reset flow
    // The 'codes' parameter is kept for backward compatibility but not used
    return this.http.post(API_URL + '/api/auth/password-reset/request', {
      email: email,
    });
  }

  public checkmail(email: string) {
    let customheader: any = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-store, must-revalidate',
        'access-control-request-headers': 'key',
      }),
      responseType: 'json',
    };
    return this.http.post(
      API_URL + '/login/checkmail',
      {
        email: email,
        key: 'bdaf624c-0fba-44e7-b001-5025493440f6',
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public getApiImages(id: string, typ: string, images: string) {
    return this.http.post(
      API_URL + '/api/getimages',
      {
        id: id,
        typ: typ,
        images: images,
        key: '541b122c-341c-448b-b3c7-43847172a576',
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public getApiPdfDok(id: string, ostammid: string, fremdid: string) {
    return this.http.post(
      API_URL + '/api/getpdf',
      {
        id: id,
        fremdid: fremdid,
        ostammid: ostammid,
        language: localStorage.getItem('language'),
        key: '541b122c-341c-448b-b3c7-43847172a589',
      },
      this.AUTH_HEADER_BIN
    );
  }

  public login(email: string, pwhash: string, db: string, karteFileID: string, clientId: string) {
    return this.http.post(
      API_URL + '/login',
      {
        email: email,
        pwhash: pwhash,
        db: db,
        karteFileID: karteFileID,
        clientId: clientId,
        sessionId: '',
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public internlogin(email: string, pwhash: string, domain: string, karteFileID: string) {
    return this.http.post(
      API_URL + '/login/internlogin',
      {
        email: email,
        pwhash: pwhash,
        domain: domain,
        karteFileID: karteFileID,
        key: '448c81ac-c1e1-4a3e-8b8b-3484a262a8e0',
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public refreshLogin(email: string, refreshToken: string, sessionId: string, clientId: string) {
    return this.http.post(
      API_URL + '/login',
      {
        email: email,
        refreshToken: refreshToken,
        sessionId: sessionId,
        clientId: clientId,
        db: localStorage.getItem('intdb'),
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public loginGetDatabases(email: string, pwhash: string) {
    return this.http.post(
      API_URL + '/login/getdatabase',
      {
        email: email,
        pwhash: pwhash,
        currentRep: localStorage.getItem('repID'),
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  //REGION FloatingLizenz
  private decodeJwtPayload(jwtToken: string): any | null {
    try {
      const parts = jwtToken.split('.');
      if (parts.length !== 3) {
        return null;
      }

      const payloadBase64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const padded = payloadBase64.padEnd(payloadBase64.length + ((4 - (payloadBase64.length % 4)) % 4), '=');
      return JSON.parse(atob(padded));
    } catch {
      return null;
    }
  }

  private hasUsableSessionId(jwtToken: string): boolean {
    const payload = this.decodeJwtPayload(jwtToken);
    const sessionId = payload?.sessionid || payload?.sessionId;
    return typeof sessionId === 'string' && sessionId.trim().length > 0;
  }

  private hasUsableJwtToken(): boolean {
    if (this.suppressLicenseRequests) {
      return false;
    }

    const jwtToken = localStorage.getItem('jwt');
    if (!jwtToken || jwtToken === 'null' || jwtToken === 'undefined') {
      return false;
    }

    const jwtExpRaw = localStorage.getItem('jwt_exp');
    const jwtExp = jwtExpRaw ? parseInt(jwtExpRaw, 10) : 0;
    if (!jwtExp || Number.isNaN(jwtExp)) {
      return false;
    }

    if (!this.hasUsableSessionId(jwtToken)) {
      return false;
    }

    return jwtExp > Math.floor(Date.now() / 1000);
  }

  public sendHeartbeat() {
    if (!this.hasUsableJwtToken()) return of('');
    return this.http.post(API_URL + '/license/heartbeat', {}, this.AUTH_HEADER).pipe(
      tap(() => {
        this.suppressLicenseRequests = false;
      }),
      catchError(error => {
        if (error?.status === 401) {
          this.suppressLicenseRequests = true;
        }
        if (error?.status !== 401) {
          console.error('Heartbeat send failed', error);
        }
        return of('');
      })
    );
  }

  public sendBreak() {
    if (!this.hasUsableJwtToken()) return of('');
    return this.http.post(API_URL + '/license/break', {}, this.AUTH_HEADER).pipe(
      tap(() => {
        this.suppressLicenseRequests = false;
      }),
      catchError(error => {
        if (error?.status === 401) {
          this.suppressLicenseRequests = true;
        }
        if (error?.status !== 401) {
          console.error('Break license failed', error);
        }
        return of('');
      })
    );
  }

  public sendRelease() {
    if (!this.hasUsableJwtToken()) return of('');
    return this.http.post(API_URL + '/license/release', {}, this.AUTH_HEADER).pipe(
      tap(() => {
        this.suppressLicenseRequests = false;
      }),
      catchError(error => {
        if (error?.status === 401) {
          this.suppressLicenseRequests = true;
        }
        if (error?.status !== 401) {
          console.error('Release license failed', error);
        }
        return of('');
      })
    );
  }
  // ENDREGION

  public logout(): Observable<any> {
    // Get JWT token for logout endpoint
    const jwtToken = localStorage.getItem('jwt');

    // Create auth header with JWT token for logout endpoint
    const logoutHeader = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, private',
        ...(jwtToken ? { Authorization: 'Bearer ' + jwtToken } : {}),
      }),
      responseType: 'json' as const,
    };

    return this.http.post(API_URL + '/login/logout', null, logoutHeader);
  }

  public resetRefreshToken(): Observable<any> {
    const jwtToken = localStorage.getItem('jwt');
    const logoutHeader = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, private',
        ...(jwtToken ? { Authorization: 'Bearer ' + jwtToken } : {}),
      }),
      responseType: 'json' as const,
    };
    return this.http.get(API_URL + '/login/resetRefreshToken', logoutHeader);
  }

  public msalLogin(email: string, token: string, initdb?: string) {
    const payload: { email: string; token: string; db?: string } = {
      email: email,
      token: token,
    };

    if (initdb) {
      payload.db = initdb;
    }

    return this.http
      .post(
        API_URL + '/login',
        payload,
        this.AUTH_HEADER_LOGIN_NO_CACHE
      )
      .pipe(
        tap(response => console.log('[MSAL] API Response:', response)),
        catchError(error => {
          console.error('[MSAL] API Error:', error);
          return throwError(() => error);
        })
      );
  }

  public send2FASMS(mobil: string, code: string) {
    return this.http.post(
      API_URL + '/login/sendsms',
      {
        mobil: mobil,
        code: code,
        key: '448c81ac-c1e1-4a3e-8b8b-3484a262a8e0',
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public getdb() {
    return this.http.post(
      API_URL + '/login/getdb',
      {
        key: '9e55218f-f038-4834-919b-78aa2cbb4b7c',
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public getURL() {
    return API_URL;
  }

  public getHEADER() {
    return this.AUTH_HEADER;
  }

  public verifyLoginFailedCode(items: any) {
    return this.http.post(
      API_URL + '/login/verifyloginfailedcode',
      {
        items: items,
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public saveGoogleCode(items: any) {
    let customheader: any = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('jwt'),
      }),
      responseType: 'json',
    };
    return this.http.post(API_URL + '/login/savegooglecode', items, customheader);
  }

  public verifyGoogleCode(items: any, token: string) {
    let customheader: any = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
      responseType: 'json',
    };
    return this.http.post(
      API_URL + '/login/verifygooglecode',
      {
        items: items,
      },
      customheader
    );
  }

  public setupGoogleCode(items: any, token: string) {
    let customheader: any = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
      responseType: 'json',
    };

    return this.http.post(
      API_URL + '/login/getgoogleauthkey',
      {
        items: items,
      },
      customheader
    );
  }

  public getnewTenantId(email: string) {
    return this.http.post(
      API_URL + '/login/getnewtenantid',
      {
        key: 'b018604a-fc94-4472-9520-1e41a84862c6',
        mail: email,
      },
      this.AUTH_HEADER_LOGIN_NO_CACHE
    );
  }

  public addZaehler(data: any): Observable<any> {
    return this.http.post(API_URL + '/tabelle-name/add', data, this.AUTH_HEADER);
  }

  public addVorlage(data: any): Observable<any> {
    return this.http.post(API_URL + '/vorlage/add', data, this.AUTH_HEADER);
  }

  // public addTabelleName(data: any): Observable<any> {
  //   return this.http.post(API_URL + "/tabelle-name/add", data, this.AUTH_HEADER);
  // }

  public testMethod() {}

  public getKarte() {
    return this.http.get(API_URL + '/karte', this.AUTH_HEADER);
  }

  public getKalender(kpruvid: number) {
    return this.http.get<Row[]>(`${API_URL}/kalender/${kpruvid}`);
  }

  public getKalenderListe(kpruvid: number) {
    return this.http.get<Table>(`${API_URL}/kalender/liste/${kpruvid}`);
  }

  public getTopoJson() {
    return firstValueFrom(this.http.get(`${API_URL}/karte/topojson`));
  }

  public refreshTopoJson(fileID: number, KPRUVID?: number, typ?: number) {
    return this.http.get(API_URL + `/karte/refreshTopoJson/${fileID}/${KPRUVID ?? 1}/${typ ?? 0}`, this.AUTH_HEADER);
  }

  public importMRproFile(send: any, id: number = 1) {
    return this.http.post(API_URL + `/karte/importmrprogis/${id}`, send, this.AUTH_HEADER);
  }

  public getObjekttypen() {
    return this.http.get(API_URL + '/karte/objtypes', this.AUTH_HEADER);
  }

  public getTOEdit(value: any) {
    return this.http.get(API_URL + '/karte/getTOEdit/' + value, this.AUTH_HEADER);
  }

  public getTOEditSchiene(value: string, bezeichnung: string) {
    return this.http.get(API_URL + '/karte/getTOEdit/' + value + '/' + bezeichnung, this.AUTH_HEADER);
  }

  public setNewFeature(values: any) {
    return this.http.post(API_URL + '/karte/newFeature', values, this.AUTH_HEADER);
  }

  public setNewSymbol(values: any) {
    return this.http.post(API_URL + '/karte/setnewSymbol', values, this.AUTH_HEADER);
  }

  public setNewTOSymbol(values: any) {
    return this.http.post(API_URL + '/karte/setnewTOSymbol', values, this.AUTH_HEADER);
  }

  public editFeature(values: any) {
    return this.http.post(API_URL + '/karte/editFeature', values, this.AUTH_HEADER);
  }

  public deleteFeature(values: any) {
    return this.http.delete(API_URL + '/karte/feature/' + values, this.AUTH_HEADER);
  }

  public applyRotation(values: any) {
    return this.http.post(API_URL + '/karte/applyRotation', values, this.AUTH_HEADER);
  }

  public saveFeatures(values: any) {
    return this.http.post(API_URL + '/karte/saveFeatures', values, this.AUTH_HEADER);
  }

  public getFKFilter() {
    return this.http.get(API_URL + '/karte/getFeatures/getFKFilter', this.AUTH_HEADER);
  }

  public getFKFilterItems(filter: any) {
    return this.http.post(API_URL + '/karte/getFeatures/getFKFilterItems', filter, this.AUTH_HEADER);
  }

  public setKColor(color) {
    return this.http.post(API_URL + '/karte/kColor', color, this.AUTH_HEADER);
  }

  public getDXF(filter: any) {
    return this.http.post(API_URL + '/karte/getDXF', filter, this.AUTH_HEADER);
  }

  public getMapPDF(filter: any) {
    return this.http.post(API_URL + '/karte/getMapPDF', filter, this.AUTH_HEADER);
  }

  public getLayerFeatures(fileID: number, key: string, KPRUVID: number, filter: any) {
    return this.http.post(API_URL + `/karte/getFeatures/${fileID}/${KPRUVID ?? 1}/${key}`, filter, this.AUTH_HEADER);
  }

  public getStammDatenBez() {
    return this.http.get(API_URL + '/karte/stammDaten', this.AUTH_HEADER);
  }

  public getStammDatenMap(fieldlist: string) {
    return this.http.get(API_URL + `/karte/stammdatenshp/${fieldlist}`, this.AUTH_HEADER);
  }

  public getKarteAnlagen(typ: number) {
    return this.http.get(API_URL + '/karte/anlagen/' + typ, this.AUTH_HEADER);
  }

  public saveMapSet(values: any) {
    return this.http.post(API_URL + '/karte/MapSet', values, this.AUTH_HEADER);
  }
  public deleteMapSet(values: any) {
    return this.http.delete(API_URL + '/karte/MapSet/' + values, this.AUTH_HEADER);
  }
  public getMapSettings() {
    return this.http.get(API_URL + '/karte/settings', this.AUTH_HEADER);
  }
  public karteCompareDate(date: string, id: number) {
    return this.http.get(API_URL + '/karte/compareStatus/' + date + '/' + id, this.AUTH_HEADER);
  }

  public newTOSymbol(values: any) {
    return this.http.post(API_URL + '/karte/getTOEdit/Add/', values, this.AUTH_HEADER);
  }

  public editTOSymbol(values: any) {
    return this.http.post(API_URL + '/karte/getTOEdit/Edit/', values, this.AUTH_HEADER);
  }

  public deleteTOSymbol(values: any) {
    return this.http.post(API_URL + '/karte/getTOEdit/Delete/', values, this.AUTH_HEADER);
  }

  public getGPKGFeatures(values: any) {
    return this.http.post(API_URL + '/karte/getGPKGFeatures/', values, this.AUTH_HEADER);
  }

  public getSysManWindow(action: string) {
    return this.http.get<Table | ObjektTypModel[]>(API_URL + '/sysMan/' + action, this.AUTH_HEADER);
  }

  public SysManStartAction(action: string, v: any, connectionId = '-') {
    return this.http.post<MRproResponseInfo<unknown>>(
      API_URL + `/sysMan/start/${action}/${connectionId}`,
      v,
      this.AUTH_HEADER
    );
  }

  public SysManGetObjList() {
    return this.http.get(API_URL + '/sysMan/objList/', this.AUTH_HEADER);
  }

  public getLogEntry(logDate, pwhash) {
    return this.http.get(API_URL + '/sysMan/log/' + logDate + '/' + pwhash, this.AUTH_HEADER);
  }

  public setupReplicate(config: SetupConfig, connectionId: string) {
    return this.http.post<MRproResponseInfo<ReplikatSetup>>(
      API_URL + `/replikat/setup/${connectionId}`,
      config,
      this.AUTH_HEADER_OBSERVE
    );
  }

  public syncbackReplicate(connectionId: string, values: ReplikatSyncBack) {
    return this.http.post<MRproResponse>(
      API_URL + `/replikat/syncback/${connectionId}`,
      values,
      this.AUTH_HEADER_OBSERVE
    );
  }

  public getMaengel(alleInspktionen: boolean, kprtypid: number) {
    return this.isRep ?
        from(this.mangelDB.GetMaengel(alleInspktionen, kprtypid))
      : this.http
          .post(API_URL + '/maengel', { alleInspektionen: alleInspktionen, kprtypid: kprtypid }, this.AUTH_HEADER_ARR)
          .pipe(switchMap(maengelData => zipAuspacken<{ all: Table; wartung: Table; stoerung: Table }>(maengelData)));
  }

  public getMaengelLog(omazsid: number) {
    return this.isRep ?
        from(this.mangelDB.GetMangelLog(omazsid))
      : this.http.get<Table<LogEintrag>>(API_URL + '/maengel/log/' + omazsid, this.AUTH_HEADER);
  }

  public getMangelMedia(filename: string) {
    return this.http.get<string>(API_URL + '/maengel/media/' + encodeURIComponent(filename), this.AUTH_HEADER);
  }

  public getMangelMediaByAuftragID(aufttagID: number) {
    return this.http.get(API_URL + '/maengel/mediabyID/' + aufttagID.toString(), this.AUTH_HEADER);
  }

  public getMangelMediaAll(names: string[]) {
    return this.isRep ?
        from(this.mangelDB.GetMangelMedia(names))
      : this.http.post<MRproResponseInfo<Media>>(API_URL + '/maengel/media/', names, this.AUTH_HEADER);
  }

  public getAnlagenMedia(filename: string) {
    return this.http.get<string>(API_URL + '/anlagen/media/' + encodeURIComponent(filename), this.AUTH_HEADER);
  }
  public getAnlagenMediaAll(names: string[]) {
    return this.isRep ?
        from(this.anlagenDB.GetAnlagenMedia(names))
      : this.http.post<MRproResponseInfo<Media>>(API_URL + '/anlagen/media/', names, this.AUTH_HEADER);
  }

  public getNewMangelValues(otypid: number, values: any) {
    return this.http.post(API_URL + '/maengel/newMangel/values/' + otypid, values, this.AUTH_HEADER);
  }

  public getNewMangelGeoDistance(ostammid: number, coords: any) {
    return this.http.post(API_URL + '/maengel/newMangel/findGeoDistance/' + ostammid, coords, this.AUTH_HEADER);
  }

  public getVectorStyle(mapname: string) {
    return this.http.get(
      'https://basemaps.arcgis.com/arcgis/rest/services/' + mapname + '/VectorTileServer/resources/styles'
    );
  }

  public getKarteStrValues() {
    return this.http.get(API_URL + '/karte/strvalues', this.AUTH_HEADER);
  }

  public getRailProfilesSelected(data: any): Observable<any> {
    return this.http.post(API_URL + '/karte/getrailprofile', data, this.AUTH_HEADER);
  }

  public getRailProfiles() {
    return this.http.get(API_URL + '/karte/getrailprofiles', this.AUTH_HEADER);
  }

  public getDocumentFile(id: any) {
    return this.http.get(API_URL + '/anlagen/getDocumentFile/' + id, this.AUTH_HEADER);
  }

  /*
  public getAnlagenQR(id: any) {
    return this.http.get(API_URL + "/anlagen/getQRLabel/" + id, this.AUTH_HEADER_LOGIN_NO_CACHE_BIN);
  }
*/
  public getQRLables(sendObj: Record<number, string>) {
    return this.http.post(API_URL + '/sysMan/getQRLables/', sendObj, this.AUTH_HEADER_BIN);
  }

  public getExportSOTYP(otypid: number) {
    return this.http.get(API_URL + `/sysMan/getExportSOTYP/${otypid}`, this.AUTH_HEADER_BIN);
  }

  public getTagesbericht(body: any): Observable<any> {
    return this.http.post(API_URL + '/anlagen/gettagesbericht/', body, this.AUTH_HEADER);
  }

  public getDokCheckMesswertAusfall(body: any): Observable<any> {
    return this.http.post(API_URL + '/anlagen/getdokmesswertausfall/', body, this.AUTH_HEADER);
  }

  public getMessdatenExport(ostammid: any, connectionId = '-') {
    return this.http.post(
      API_URL + `/anlagen/getmessreg/${connectionId}`,
      { ostammid: ostammid, language: localStorage.getItem('language') },
      this.AUTH_HEADER_BIN
    );
  }

  public getPDFFile(opruefid: any, connectionId = '-') {
    return this.http.post(
      API_URL + `/anlagen/getPDFFile/${connectionId}`,
      { opruefid: opruefid, language: localStorage.getItem('language') },
      this.AUTH_HEADER_BIN
    );
  }

  public setSAPExport(opruefid: any, connectionId = '-') {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('jwt')}`,
    });

    return this.http.post(`${API_URL}/sap/setexport/${connectionId}`, { opruefid }, { headers });
  }

  public getSAPSynchronize() {
    return this.http.get(API_URL + '/sap/getsapsynchronize', this.AUTH_HEADER);
  }

  public getDatabaseBackUp(connectionId: string) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
    });

    return this.http.get<{ backupFileName: string; fileid: string }>(
      `${API_URL}/files/getDatabaseBackUp/${connectionId}`,
      {
        headers: headers,
      }
    );
  }

  public getsBackupFolderInfo() {
    return this.http.get(API_URL + '/files/getbackupfoldersinfo', this.AUTH_HEADER);
  }

  public createFilesBackUp(connectionId: string, path: string) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
    });

    return this.http.get<{ backupFileName: string; fileid: string }>(
      `${API_URL}/files/createfilesbackup/${connectionId}/${path}`,
      {
        headers: headers,
      }
    );
  }

  public downloadExcelFile(excelPath: string) {
    let customheader: any = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('jwt'),
      }),
      responseType: 'blob',
    };
    return this.http.post(API_URL + '/anlagen/downloadExcelFile/', { path: excelPath }, customheader);
  }

  public uploadFiles(formData: any) {
    return this.http.post(API_URL + '/files/uploadfiles', formData, this.AUTH_HEADER_OBSERVE);
  }

  public getRailmonitor(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/railmonitor/' + ostammid, this.AUTH_HEADER);
  }
  public getRailmonitorSollprofile() {
    return this.http.get(API_URL + '/anlagen/railmonitor/sollprofile', this.AUTH_HEADER);
  }
  public deleteRailmonitor(id: number): Observable<any> {
    return this.http.delete(API_URL + '/anlagen/railmonitor/' + id, this.AUTH_HEADER);
  }
  public getRailmonitorImport(formData: any) {
    return this.http.post(API_URL + '/anlagen/railmonitor/data', formData, this.AUTH_HEADER);
  }
  public saveRailmonitorImport(ostammid: number, formData: any) {
    return this.http.post(API_URL + '/anlagen/railmonitor/import/' + ostammid, formData, this.AUTH_HEADER);
  }

  public getFirmen() {
    return this.http.get<Table<Firma>>(API_URL + '/anlagen/firmen', this.AUTH_HEADER);
  }

  public getKundenBezeichnung() {
    return this.http.get(API_URL + '/anlagen/kundenbezeichnung', this.AUTH_HEADER);
  }

  public getINIOptions(): Observable<any> {
    return this.isRep ?
        from(this.einstellungenDB.GetINIOptions())
      : this.http.get<Table>(API_URL + '/anlagen/inioptions', this.AUTH_HEADER);
  }

  public getFirmenAll() {
    return this.http.get(API_URL + '/anlagen/firmenall', this.AUTH_HEADER);
  }

  public getFirmenUserGruppen(groupid: number) {
    return this.http.get(API_URL + '/anlagen/firmen/groups/' + groupid, this.AUTH_HEADER);
  }

  public setFirmenUserGruppen(editarr: any) {
    return this.http.post(API_URL + '/anlagen/firmen/groups/edit', editarr, this.AUTH_HEADER);
  }

  public getFormulare(): Observable<any> {
    return this.http.get(API_URL + '/formulare', this.AUTH_HEADER);
  }

  public getGroupsForFat(): Observable<any> {
    return this.http.get(API_URL + '/groups/fat', this.AUTH_HEADER);
  }

  public getTabellenFAT(): Observable<any> {
    return this.http.get(API_URL + '/tabellenFAT', this.AUTH_HEADER);
  }

  public getStammdatenColumns(): Observable<any> {
    return this.http.get(API_URL + '/ostamm/columns', this.AUTH_HEADER);
  }

  public getSpezifikationsdaten(): Observable<any> {
    return this.http.get(API_URL + '/kspezv/data', this.AUTH_HEADER);
  }

  public initMangelbaum(id: string | number): Observable<any> {
    return this.http.get(API_URL + '/anlagen/mangelbaum/init/' + id, this.AUTH_HEADER);
  }

  public getHerstellerdatenColumns(): Observable<any> {
    return this.http.get(API_URL + '/oherst/columns', this.AUTH_HEADER);
  }

  public getFieldStructures() {
    return this.http.get(API_URL + '/get-field-type', this.AUTH_HEADER);
  }

  public getFatFieldValueByID(ostammid: number, lpid: number) {
    return this.http.get(API_URL + '/anlagen/getfatfieldvalue/' + ostammid + '/' + lpid, this.AUTH_HEADER);
  }

  public getFieldType(columnName: string | null, rowName: string | null): Observable<any> {
    let params = new HttpParams().set('columnName', columnName);
    params = params.set('rowName', rowName);
    return this.http.get(API_URL + '/get-field-type', {
      ...this.AUTH_HEADER,
      params: params,
    });
  }

  public getVorlageNames(): Observable<any> {
    return this.http.get(API_URL + '/vorlage-names', this.AUTH_HEADER);
  }

  public getTabellenNamesFAT(vorlageID: number): Observable<any> {
    return this.http.get(API_URL + '/tabellen-names-fat/' + vorlageID, this.AUTH_HEADER);
  }
  public getFormDataForVorlage(vorlageID: number): Observable<any> {
    return this.http.get(API_URL + '/form-data/' + vorlageID, this.AUTH_HEADER);
  }

  public getTabellenDataFATBySZAEHNID(szaehnID: number): Observable<any> {
    return this.http.get(API_URL + '/tabellen-data-FAT/' + szaehnID, this.AUTH_HEADER);
  }

  public getFilteredTablesAndTitlesForAig(): Observable<any> {
    return this.http.get(API_URL + '/filtered-tables-and-titles-for-aig', this.AUTH_HEADER);
  }

  public getFilteredTablesAndTitlesForPI(): Observable<any> {
    return this.http.get(API_URL + '/filtered-tables-and-titles-for-pi', this.AUTH_HEADER);
  }

  public getCheckboxState(tabelleID: number): Observable<any> {
    return undefined;
    //return this.http.get(API_URL + "/checkbox/" + tabelleID, this.AUTH_HEADER);
  }

  public getTabelleIDForVorlage(vorlageID: number): Observable<any> {
    return this.http.get(API_URL + '/tabellen/gettabelleIDforvorlage/' + vorlageID, this.AUTH_HEADER);
  }

  public getAllZaehlerForObject(ostammid: number): Observable<any> {
    return this.http.get(API_URL + '/anlagen/getallzaehlerforobject/' + ostammid, this.AUTH_HEADER);
  }

  public getGroupObjects(groupid: number) {
    return this.http.get<{ addedObjects: Table; leftObjects: Table }>(
      API_URL + '/groups/objects/' + groupid,
      this.AUTH_HEADER
    );
  }

  public getAuftragGroupObjects(groupid: number) {
    return this.http.get<{ addedObjects: Table; leftObjects: Table }>(
      API_URL + `/auftraggroups/objects/${groupid}`,
      this.AUTH_HEADER
    );
  }

  public setAuftragGroupObjects(groupid: number, IDs: number[]) {
    return this.http.post<MRproResponse>(API_URL + `/auftraggroups/objects/${groupid}`, IDs, this.AUTH_HEADER);
  }

  public removeAuftragGroupObjects(IDs: number[]) {
    return this.http.delete<MRproResponse>(API_URL + '/auftraggroups/objects', {
      body: IDs,
      ...this.AUTH_HEADER,
    });
  }

  public deleteAuftragGroup(groupid: number) {
    return this.http.get(API_URL + '/auftraggroups/delete/' + groupid, this.AUTH_HEADER);
  }

  public getUserFromGroup(groupid: number) {
    return this.http.get(API_URL + '/groups/' + groupid, this.AUTH_HEADER);
  }

  public getUserFromAuftragGroup(groupid: number) {
    return this.http.get(API_URL + '/auftraggroups/' + groupid, this.AUTH_HEADER);
  }

  public CheckPWAdmin(hash: any): Observable<any> {
    return this.http.post(API_URL + '/login/checkadmpw', hash, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('jwt'),
      }),
      responseType: 'json',
    });
  }

  public getRoleByID(id): Observable<any> {
    return this.http.get(API_URL + '/roles/' + id, this.AUTH_HEADER);
  }

  public getRoles(): Observable<any> {
    return this.http.get(API_URL + '/roles', this.AUTH_HEADER);
  }

  public getPWini(): Observable<any> {
    return this.isRep ? of(null) : this.http.get(API_URL + '/users/pwini', this.AUTH_HEADER);
  }

  public getGroups() {
    return this.http.get<Gruppe[]>(API_URL + '/groups', this.AUTH_HEADER);
  }

  public getMessTol() {
    return this.http.get<{
      toleranzen: Table<KTOLR>;
      ini: { optMessTol: number; optMessTolBez: string };
      sotyp: Table<SOTYP>;
    }>(API_URL + '/anlagen/toleranzen', this.AUTH_HEADER);
  }

  public getChecklistenItems(items: { status: 'get'; OTYPID: number }): Observable<{ name: Table<{ Titel: string }> }>;
  public getChecklistenItems(items: any): Observable<any>;
  public getChecklistenItems(items: any): Observable<any> {
    return (
      this.isRep ?
        items.status == 'get' ?
          from(this.mangelDB.GetChecklistenTitels(items.OTYPID))
        : of(null)
      : this.http.post(API_URL + '/anlagen/getchecklistenitems', items, this.AUTH_HEADER)
    );
  }

  public ImportGrenzwertverletzungen(items: any) {
    return this.http.post(API_URL + '/files/importgrenzwertverletzungen ', items, this.AUTH_HEADER);
  }

  public ReSetMessWertFehler(items: any) {
    return this.http.post(API_URL + '/anlagen/resetmesswertfehler ', items, this.AUTH_HEADER);
  }

  public getMessungTol(items: any) {
    return this.http.post(API_URL + '/anlagen/getmessungtol', items, this.AUTH_HEADER);
  }

  public getMessungAuswertung(items: any) {
    return this.isRep ?
        from(this.db.getMessungAuswertung(items))
      : this.http.post(API_URL + '/anlagen/getmessungauswertung', items, this.AUTH_HEADER);
  }

  public getAlerts() {
    return this.http.get(API_URL + '/anlagen/getalerts', this.AUTH_HEADER);
  }

  public getSOTYP() {
    return this.isRep ?
        from(this.anlagenDB.GetSOTYP())
      : this.http.get<SOTYP_Map>(API_URL + '/anlagen/sotyp', this.AUTH_HEADER);
  }

  public getSOTYPAll() {
    return this.http.get<Table>(API_URL + '/anlagen/sotypall', this.AUTH_HEADER);
  }

  public getPruefungsVerwaltung() {
    return this.http.get(API_URL + '/anlagen/getpruefungsverwaltung', this.AUTH_HEADER);
  }

  public setPruefungsVerwaltung(items: any) {
    return this.http.post(API_URL + '/anlagen/setpruefungsverwaltung', items, this.AUTH_HEADER);
  }

  public getVorlagenFiles(id: number) {
    return this.http.get(API_URL + '/anlagen/getpaintvorlagen/' + id, this.AUTH_HEADER);
  }

  public getObjektPruefungTypen() {
    return this.http.get<Table>(API_URL + '/anlagen/objektpruefungtypen', this.AUTH_HEADER);
  }

  public getCurrentMessung(ostammid: number, opruefid: number): Observable<any> {
    return this.http.get(API_URL + `/anlagen/messung/${ostammid}/${opruefid}`, this.AUTH_HEADER);
  }

  public getKomponenten(id: number) {
    return this.http.get(API_URL + '/anlagen/komponenten/' + id, this.AUTH_HEADER);
  }

  public getObjectKomponenten(stammid: string, otypid:string) {
    return this.http.get(API_URL + '/anlagen/komponenten/object/' + stammid + "/" + otypid, this.AUTH_HEADER);
  }

  public setObjectKomponenten(komp: any) {
    return this.http.post(API_URL + '/anlagen/setkomponenten', komp, this.AUTH_HEADER);
  }

  public setPaintItems(items: any, option: string) {
    if (option == '') {
      return this.http.post(API_URL + '/anlagen/setpaintitems', items, this.AUTH_HEADER);
    } else {
      let customheader: any = {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem('jwt'),
        }),
        responseType: 'blob',
      };
      return this.http.post(
        API_URL + '/anlagen/getpaintpdf',
        { items: items, language: localStorage.getItem('language') },
        customheader
      );
    }
  }

  public convertIFCFiles(base64: any) {
    return this.http.post(API_URL + '/anlagen/convertIFCFiles/', base64, this.AUTH_HEADER_BIN);
  }

  public getPaintItemList(stammid: string) {
    return this.http.get(API_URL + '/anlagen/getpaintitemslist/' + stammid, this.AUTH_HEADER);
  }

  public getPaintItem(stammid: string, id: string) {
    return this.http.get(API_URL + '/anlagen/getpaintitemslist/' + stammid + '/' + id, this.AUTH_HEADER);
  }

  public setSonderinspektion(items: any) {
    return this.http.post(API_URL + '/maengel/setsonderinspektion', items, this.AUTH_HEADER);
  }

  public getSonderinspektion(osispkid: string, otypid: string) {
    return this.http.get(API_URL + '/maengel/getsonderinspektion/' + osispkid + '/' + otypid, this.AUTH_HEADER);
  }

  public getSonderinspektionListe(ostammid: string) {
    return this.http.get(API_URL + '/maengel/getsonderinspektionliste/' + ostammid, this.AUTH_HEADER);
  }

  public getObjectKomponentenChildren(id: any) {
    return this.http.get(API_URL + '/anlagen/komponentenchildren/' + id, this.AUTH_HEADER);
  }

  public getKspezErneuerung(id: number) {
    return this.http.get(API_URL + '/anlagen/getkspezerneuerung/' + id, this.AUTH_HEADER);
  }

  public getKSPEZVSelected(otypid: number, feld: string) {
    return this.isRep ?
        from(this.anlagenDB.GetSelectionFromOSPEZ(otypid, feld))
      : this.http.get<string[]>(API_URL + '/anlagen/getkspev/' + otypid + '/' + feld, this.AUTH_HEADER);
  }

  public getAnlagenFilterStammIDs(otypid: number, sendObj: { FilterFeld: string; FilterSelected: string[] }) {
    return this.isRep ?
        from(this.anlagenDB.FindObjekteByStammdaten(otypid, sendObj))
      : this.http.post<number[]>(API_URL + `/anlagen/getanlagenfilterstammid/${otypid}`, sendObj, this.AUTH_HEADER);
  }

  public getKSPEZVUsed() {
    return this.isRep ?
        from(this.anlagenDB.GetKSPEZV_Used())
      : this.http.get<StammAuswahl[]>(API_URL + '/anlagen/getkspevused', this.AUTH_HEADER);
  }

  public getKRPUV() {
    return this.isRep ?
        from(this.anlagenDB.GetKundenPrüfungenTypen())
      : this.http.get<KundenPrüfungTypen>(API_URL + '/anlagen/getkpruv', this.AUTH_HEADER);
  }

  public getSysObjectOptions() {
    return this.http.get<Table>(API_URL + '/anlagen/sysoopt', this.AUTH_HEADER);
  }

  public getAuftragsGroups() {
    return this.http.get<Gruppe[]>(API_URL + '/auftraggroups', this.AUTH_HEADER);
  }
  public getSettingsKav() {
    return this.http.get(API_URL + '/settings/kav', this.AUTH_HEADER);
  }

  public getSettingsApiKeys() {
    return this.http.get(API_URL + '/settings/apikeys', this.AUTH_HEADER);
  }

  public getLogFiles() {
    return this.http.get(API_URL + '/settings/getlogfiles', this.AUTH_HEADER);
  }

  public getSettingsInterface(items: any) {
    return this.http.post(API_URL + '/settings/interface', items, this.AUTH_HEADER);
  }

  public getSettingsKunde() {
    return this.http.get(API_URL + '/settings/kunde', this.AUTH_HEADER);
  }

  public setAnlagenALVStatus(status: any) {
    return this.http.post(API_URL + '/anlagen/setalv', status, this.AUTH_HEADER);
  }

  public setSettingsBezeichnung(bez: any) {
    return this.http.post(API_URL + '/anlagen/settings/kundenbezeichnung', bez, this.AUTH_HEADER);
  }

  public setSettingsApiKeys(apiKeys: any) {
    return this.http.post(API_URL + '/settings/apikeys', apiKeys, this.AUTH_HEADER);
  }

  public setRole(body: any) {
    return this.http.post(API_URL + '/roles/update', body, this.AUTH_HEADER);
  }

  public setGroupObjects(groupid: number, karteid: number, IDs: { OSTAMMID: number; OTYPID: number }[]) {
    return this.http.post<MRproResponse>(API_URL + `/groups/objects/${groupid}/${karteid}`, IDs, this.AUTH_HEADER);
  }

  public removeGroupObjects(groupid: number, IDs: number[]) {
    return this.http.delete<MRproResponse>(API_URL + `/groups/objects/${groupid}`, { body: IDs, ...this.AUTH_HEADER });
  }

  public setUserGroups(group: any) {
    return this.http.post(API_URL + '/usergroups/edit', group, this.AUTH_HEADER);
  }

  public setGroups(group: any): Observable<any> {
    return this.http.post(API_URL + '/groups/edit', group, {
      headers: this.AUTH_HEADER.headers,
      observe: 'body',
    });
  }

  public setAuftragGroups(group: any) {
    return this.http.post(API_URL + '/auftraggroups/edit', group, this.AUTH_HEADER);
  }

  public getUser(userid: number) {
    return this.http.get(API_URL + '/users/' + userid, this.AUTH_HEADER);
  }

  public getUsers() {
    return this.http.get<Table<User>>(API_URL + '/users', this.AUTH_HEADER);
  }

  public getGisMappingBVB() {
    return this.http.get(API_URL + `/stamm/getgismapping`, this.AUTH_HEADER);
  }
  public ImportBVBSpezifikationen(bauform: any): Observable<any> {
    return this.http.post(API_URL + '/spez/importspezbvb', bauform, this.AUTH_HEADER);
  }

  public ImportBVBRadius(radius: any): Observable<any> {
    return this.http.post(API_URL + '/spez/importradiusbvb', radius, this.AUTH_HEADER);
  }

  public getBerichte(): Observable<any> {
    return this.http.get(API_URL + '/berichte', this.AUTH_HEADER);
  }
  public setBerichte(berichte: any): Observable<any> {
    return this.http.post(API_URL + '/berichte', berichte, this.AUTH_HEADER);
  }

  public getAnlagen(
    kpruvid: number,
    {
      userId = 0,
      all = false,
      onlyEditRights = false,
    }: {
      userId?: number;
      all?: boolean;
      onlyEditRights?: boolean;
    } = {}
  ) {
    return this.isRep ?
        from(this.anlagenDB.GetAnlagen(kpruvid))
      : this.http
          .get(`${API_URL}/anlagen`, { responseType: 'arraybuffer', params: { kpruvid, userId, all, onlyEditRights } })
          .pipe(switchMap(anlagen => zipAuspacken<Table>(anlagen)));
  }

  public getKostenAuftrag(auftragId: number) {
    return this.http.get<Table>(API_URL + '/anlagen/kosten/auftrag/' + auftragId, this.AUTH_HEADER);
  }

  public setFremdleistungPlanenAuftrag(newKosten: any) {
    return this.http.post(API_URL + '/anlagen/kosten/auftrag/planefremdleistung', newKosten, this.AUTH_HEADER);
  }

  public setKostenAuftrag(typ: string, newKosten: any) {
    return this.http.post(API_URL + '/anlagen/kosten/auftrag/' + typ, newKosten, this.AUTH_HEADER);
  }

  public getKostenTaetigkeiten() {
    return this.http.get(API_URL + '/anlagen/kosten/taetigkeiten', this.AUTH_HEADER);
  }

  public getKostenPersonal() {
    return this.http.get(API_URL + '/anlagen/kosten/personal', this.AUTH_HEADER);
  }

  public updateKostenPersonal(id: number, kostenPersonal: any) {
    return this.http.post(API_URL + '/anlagen/kosten/personal/' + id, kostenPersonal, this.AUTH_HEADER);
  }

  public getKostenMaterial(optInterface) {
    return this.http.get(API_URL + '/anlagen/kosten/material/' + optInterface, this.AUTH_HEADER);
  }

  public updateKostenMaterial(id: number, kostenPersonal: any) {
    return this.http.post(API_URL + '/anlagen/kosten/material/' + id, kostenPersonal, this.AUTH_HEADER);
  }

  public setCloseEAMAuftrag(item: any) {
    return this.http.post(API_URL + '/auftrag/closeeamauftrag', item, this.AUTH_HEADER);
  }

  public getHxGNEAMBestellung(items: any) {
    return this.http.post(API_URL + '/anlagen/kosten/gethxgneambestellung', items, this.AUTH_HEADER);
  }

  public importHxGNEAMKosten(type: string) {
    return this.http.get(API_URL + '/anlagen/kosten/updatehxgneamkosten/' + type, this.AUTH_HEADER);
  }

  public getKostenMaschinen() {
    return this.http.get(API_URL + '/anlagen/kosten/maschinen', this.AUTH_HEADER);
  }

  public updateKostenMaschinen(id: number, kostenPersonal: any) {
    return this.http.post(API_URL + '/anlagen/kosten/maschinen/' + id, kostenPersonal, this.AUTH_HEADER);
  }

  public getKostenFremdleistung() {
    return this.http.get(API_URL + '/anlagen/kosten/fremdleistungen', this.AUTH_HEADER);
  }

  public getKostenFremdleistungEinheiten() {
    return this.http.get<string[]>(API_URL + '/anlagen/kosten/fremdleistungen/einheiten', this.AUTH_HEADER);
  }

  public insertKostenFremdleistungTitel(titel: string) {
    return this.http.post(API_URL + '/anlagen/kosten/fremdleistungen/titel', { Kurztext: titel }, this.AUTH_HEADER);
  }

  public updateKostenFremdleistungTitel(id: number, titel: string) {
    return this.http.put(
      API_URL + '/anlagen/kosten/fremdleistungen/titel/' + id,
      { Kurztext: titel },
      this.AUTH_HEADER
    );
  }

  public insertKostenFremdleistung(kostenFremdleistung: FremdleistungInput) {
    return this.http.post(API_URL + '/anlagen/kosten/fremdleistungen/', kostenFremdleistung, this.AUTH_HEADER);
  }

  public updateKostenFremdleistung(id: number, kostenFremdleistung: FremdleistungUpdateInput) {
    return this.http.put(API_URL + '/anlagen/kosten/fremdleistungen/' + id, kostenFremdleistung, this.AUTH_HEADER);
  }

  public deleteKostenFremdleistung(id: number, type: string) {
    return this.http.delete(API_URL + '/anlagen/kosten/' + type + '/' + id, this.AUTH_HEADER);
  }

  public getAuftraege() {
    return this.http
      .get(API_URL + '/auftraege', this.AUTH_HEADER_ARR)
      .pipe(switchMap(auftraege => zipAuspacken<Table>(auftraege)));
  }

  public getNeuAuftraegWerte() {
    return forkJoin({
      titel: this.getUniqueFeldFromTable('kauftr', 'Titel'),
      kostenart: this.getUniqueFeldFromTable('kauftr', 'Kostenart'),
      auftragart: this.getUniqueFeldFromTable('kauftr', 'Auftragart'),
    });
  }

  public getAuftragDetailWerte() {
    return forkJoin({
      verantwortlicher: this.getUniqueFeldFromTable('omazs', 'Verantwortlich'),
      kostenart: this.getUniqueFeldFromTable('omazs', 'Kostenart'),
    });
  }

  public getListAltInstandsetzung(ostammid) {
    return this.http.get(API_URL + '/baseitems/common/getihlist/' + ostammid, this.AUTH_HEADER);
  }

  public getAuftraegeMaengelAll() {
    return this.http
      .get(API_URL + '/auftraege/mangel/all', this.AUTH_HEADER_ARR)
      .pipe(switchMap(maengel => zipAuspacken<Table>(maengel)));
  }

  public getAuftraegeObjekteAll() {
    return this.http
      .get(API_URL + '/auftraege/objekte/all', this.AUTH_HEADER_ARR)
      .pipe(switchMap(objekte => zipAuspacken<Table>(objekte)));
  }

  public getAuftraegeListe() {
    return this.http.get(API_URL + '/auftraege/liste', this.AUTH_HEADER);
  }

  public getAuftragPDF(kauftrid: number) {
    let language = localStorage.getItem('language');
    return this.http.get(API_URL + '/auftraege/setPDF/' + kauftrid + '/' + language, this.AUTH_HEADER_BIN);
  }

  public getAuftraegeObjekte(kauftrid: number) {
    return this.http.get(API_URL + '/auftraege/objekte/' + kauftrid, this.AUTH_HEADER);
  }

  public getAuftraegeInhalt(kauftsid: number) {
    return this.http.get(API_URL + '/auftraege/inhalt/' + kauftsid, this.AUTH_HEADER);
  }

  public getCoorinates(id: number) {
    return this.http.get(API_URL + '/anlagen/getCoordinate/' + id, this.AUTH_HEADER);
  }

  public getProfileList(id: number) {
    return this.http.get<ProfileResponse>(API_URL + '/anlagen/getProfileList/' + id, this.AUTH_HEADER);
  }

  public getPruefid(id: number, table: string) {
    return this.http.get(API_URL + '/anlagen/getPruefid/' + id + '/' + table, this.AUTH_HEADER);
  }

  public getMessungen(pruefid: string, id: number) {
    return this.http.get(API_URL + '/anlagen/messungen/' + id + '/' + pruefid, this.AUTH_HEADER_ARR);
  }

  public setMessungenMirrow(pruefid: number, body: any) {
    return this.http.post(API_URL + '/anlagen/messungspiegeln/' + pruefid, body, this.AUTH_HEADER);
  }

  public setUpdateMessungen(pruefid: number, body: any) {
    return this.http.post(API_URL + '/anlagen/updatemessung/' + pruefid, body, this.AUTH_HEADER);
  }

  public getMessungGeo(id: number) {
    return this.http.get(API_URL + '/anlagen/geo/' + id, this.AUTH_HEADER);
  }

  public getMessungBauwerke(stammid: number) {
    return this.http.get(API_URL + '/anlagen/messungen/bauwerke/' + stammid, this.AUTH_HEADER);
  }

  public getMessungLaengswelligkeit(id: number, typ: number) {
    return this.http.get(API_URL + '/anlagen/messungenlaengswelligkeit/' + id + '/' + typ, this.AUTH_HEADER_ARR);
  }

  public getStellkraftMessungen(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/stellkraftmessung/' + ostammid, this.AUTH_HEADER);
  }

  public setStellkraftMessung(body: any) {
    return this.http.post(API_URL + '/anlagen/stellkraftmessung/', body, this.AUTH_HEADER);
  }

  public getStellkraftCMS(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/stellkraftCMS/', this.AUTH_HEADER);
  }

  public getAnlagenHistorie(id: number): Observable<any> {
    return this.isRep ?
        from(this.db.getAnlagenHistorie(id))
      : this.http.get(API_URL + '/anlagen/historie/' + id, this.AUTH_HEADER_NO_CACHE);
  }
  public getAnlagenLogbuch(id: number) {
    return this.http.get<Table<LogEintrag>>(API_URL + '/anlagen/logbuch/' + id, this.AUTH_HEADER);
  }

  public getAnlagenCamBilder(id: number) {
    return this.http.get<CamImageResponse>(`${API_URL}/anlage/getcambilder/${id}`, this.AUTH_HEADER);
  }

  public getProfile(id: string, file: string) {
    return this.http.get<Profil[]>(`${API_URL}/files/profile/${id}/${encodeURIComponent(file)}`, this.AUTH_HEADER);
  }

  public getAnlagenCamBild(id: number, file: string, direction: boolean = false) {
    return this.http.get(`${API_URL}/files/getcambild/${id}/${encodeURIComponent(file)}/${direction}`, {
      ...this.AUTH_HEADER,
      responseType: 'blob',
    });
  }

  public setAnlagenLogbuch(items: any) {
    return this.http.post(API_URL + '/anlagen/setlogbuch', items, this.AUTH_HEADER);
  }
  // public sendAnlagenMessage(id: number, type:string) {
  //   return this.http.get(API_URL + "/anlagen/SendAnlagenMessage/" + id + "/"+ type, this.AUTH_HEADER_NO_CACHE);
  // }

  public sperrAnlage(ostammid: number) {
    return this.http.get<MRproResponseInfo<{ username: string }>>(
      API_URL + `/anlage/sperr/${ostammid}`,
      this.AUTH_HEADER
    );
  }

  public entsperrAnlage(ostammid: number) {
    return this.http.get(API_URL + `/anlage/entsperr/${ostammid}`, this.AUTH_HEADER);
  }

  public entsperrAnlageSync(ostammid: number) {
    const db = localStorage.getItem('DB');
    const username = sessionStorage.getItem('UserName');
    this.beacon('anlage/entsperr', { db, username, ostammid });
  }

  public getAnlage(id: number, kpruvid: number = 1) {
    return this.isRep ?
        from(this.anlagenDB.GetAnlageByID(id, kpruvid))
      : this.http.get<DetailViewResponse>(API_URL + `/anlage/${id}/${kpruvid}`, this.AUTH_HEADER_NO_CACHE);
  }
  public getFKColors() {
    return this.isRep ?
        this.einstellungenDB.GetFKColors()
      : firstValueFrom(this.http.get<string[]>(API_URL + '/anlagen/getFKColor'));
  }

  public getStatistiken() {
    return this.http.get(API_URL + '/statistiken', this.AUTH_HEADER);
  }

  public getStatistikKAV(field: any) {
    return this.isRep ? of(null) : this.http.post(API_URL + '/statistik/KAV/' + field, this.AUTH_HEADER);
  }

  public getStatistikKAVDetail(typ: number, field: any, value: any, ostammid: number) {
    return this.isRep ?
        of(null)
      : this.http.get(
          API_URL + '/statistik/KAV/detail/' + typ + '/' + field + '/' + value + '/' + ostammid,
          this.AUTH_HEADER
        );
  }

  public getStatistik(body: any) {
    return this.isRep ? of(null) : this.http.post(API_URL + '/statistik', body, this.AUTH_HEADER);
  }

  public getHistoryItem(ostammid: number, search: HistorieNode) {
    return this.isRep ?
        from(this.db.getHistoryItem(ostammid, search))
      : this.http.post<Table>(API_URL + '/anlagen/history/' + ostammid, search, this.AUTH_HEADER);
  }

  public getAnlagenAuftrag(stammid: number, typ: number) {
    return this.http.get(API_URL + '/anlagen/auftrag/' + stammid + '/' + typ, this.AUTH_HEADER);
  }

  public getAnlageProfilCount(id: number) {
    return this.http.get(API_URL + '/anlagen/profile/count/' + id, this.AUTH_HEADER);
  }
  public setAnlageProfilRecalc(profil: any) {
    return this.http.post(API_URL + '/anlagen/profile/recalc/', profil, this.AUTH_HEADER);
  }
  public getAnlageProfil(id: number, pruefids: string) {
    return this.http.get(API_URL + '/anlagen/profile/' + id + '/' + pruefids, this.AUTH_HEADER_ARR);
  }

  public setAnlageProfil(profile: any) {
    return this.http.post(API_URL + '/anlagen/profile/', profile, this.AUTH_HEADER);
  }

  public getStoerung(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/stoerung/' + ostammid, this.AUTH_HEADER);
  }

  public getStoerungMassnahmen(omazsid: number) {
    return this.http.get(API_URL + '/anlagen/stoerung/massnahmen/' + omazsid, this.AUTH_HEADER);
  }

  public getStoerungMangel(pruefartid: number) {
    return this.http.get(API_URL + '/anlagen/stoerung/mangel/' + pruefartid, this.AUTH_HEADER);
  }
  public getStoerungRueckmeldung(req: any) {
    return this.http.post(API_URL + '/anlagen/rueckmeldung/stoerung', req, this.AUTH_HEADER);
  }
  public getSperrung(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/sperrung/' + ostammid, this.AUTH_HEADER);
  }

  public geAlkisZoordnung(otypid: number) {
    return this.http.get<AlkisAPI>(API_URL + '/stamm/alkis/' + otypid, this.AUTH_HEADER);
  }

  public getLastelle(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/langsamfahrstelle/' + ostammid, this.AUTH_HEADER);
  }

  public getProject(year: number) {
    return this.http.get<Table<User>>(API_URL + '/projekt/table/' + year, this.AUTH_HEADER);
  }
  public getProjectYears() {
    return this.http.get<any>(API_URL + '/projekt/getyears', this.AUTH_HEADER);
  }
  public getOpenProject(id: number) {
    return this.http.get(API_URL + '/projekt/openproject/' + id, this.AUTH_HEADER);
  }
  public setSaveProject(body: any) {
    return this.http.post<any>(API_URL + '/projekt/saveproject', body, this.AUTH_HEADER);
  }
  public setUpdateProject(body: any) {
    return this.http.post<any>(API_URL + '/projekt/updateproject', body, this.AUTH_HEADER);
  }
  public getDeleteProject(id: number) {
    return this.http.get<any>(API_URL + '/projekt/deleteproject/' + id, this.AUTH_HEADER);
  }
  public setDeleteProjectAnlage(body: any) {
    return this.http.post(API_URL + '/projekt/deleteAnlage/', body, this.AUTH_HEADER);
  }
  public setSaveSpezProject(id: number, res) {
    return this.http.post(API_URL + '/projekt/saveSpez/' + id, res, this.AUTH_HEADER);
  }
  public getProjektMaengel(id: number) {
    return this.http.get(API_URL + '/projekt/getMaengel/' + id, this.AUTH_HEADER);
  }
  public sendKAVsettings(kav: any) {
    return this.http.post(API_URL + '/settings/kav', kav, this.AUTH_HEADER);
  }

  public sendMessTol(mess: any) {
    return this.http.post(API_URL + '/anlagen/toleranzen', mess, this.AUTH_HEADER);
  }

  public sendSysObjectOptions(sysoopt: any) {
    return this.http.post(API_URL + '/anlagen/sysoopt', sysoopt, this.AUTH_HEADER);
  }

  public sendINIsettings(ini: any) {
    return this.http.post(API_URL + '/settings/ini', ini, this.AUTH_HEADER);
  }

  public sendSammel(items: any) {
    return this.http.post(API_URL + '/anlagen/sendsammelexport', items, this.AUTH_HEADER);
  }

  public sendKLINIEN(linie: any) {
    return this.http.post(API_URL + '/anlagen/klinie', linie, this.AUTH_HEADER);
  }

  // public sendSBFEK(codes: any) {
  //   return this.isRep? from(this.db.getSBFEK(codes)) : this.http.post(API_URL + "/anlagen/sbfek", codes, this.AUTH_HEADER);
  // }

  public sendOSTEDT(trass: any) {
    return this.http.post(API_URL + '/anlagen/ostedt', trass, this.AUTH_HEADER);
  }

  public sendSOTYP(sotyp: any) {
    return this.http.post(API_URL + '/anlagen/sotyp', sotyp, this.AUTH_HEADER);
  }

  public importSOTYP(connectionId: string, sendObj: ImportObjektTypTable[]) {
    return this.http.post<MRproResponse>(API_URL + `/sysMan/importsotyp/${connectionId}`, sendObj, this.AUTH_HEADER);
  }

  public sendObjektKAV(ostammid: number, kav: boolean) {
    return this.http.post(API_URL + '/anlagen/kav/' + ostammid, { kav: kav }, this.AUTH_HEADER);
  }

  public berechneKAV(ostammid: number) {
    return this.http.get(API_URL + '/anlagen/berechneKAV/' + ostammid, this.AUTH_HEADER);
  }

  public sendLastelle(ostammid: number, lastelle: any) {
    return this.http.post(API_URL + '/anlagen/langsamfahrstelle/' + ostammid, lastelle, this.AUTH_HEADER);
  }

  public sendStoerung(ostammid: number, stoerung: any) {
    return this.http.post(API_URL + '/anlagen/stoerung/' + ostammid, stoerung, this.AUTH_HEADER);
  }

  public sendSperrung(ostammid: number, sperrung: any) {
    return this.http.post(API_URL + '/anlagen/sperrung/' + ostammid, sperrung, this.AUTH_HEADER);
  }

  public deleteAuftrag(aufragId: number) {
    return this.http.delete(API_URL + '/auftrag/delete/' + aufragId, this.AUTH_HEADER);
  }

  public importHxGNAuftrag(id: string) {
    return this.http.get<MRproResponseInfo<AuftragImportInfor>>(
      API_URL + `/auftrag/getinfoauftrag/${id}`,
      this.AUTH_HEADER
    );
  }

  public getAuftragInforUrl(): Observable<any> {
    return this.http.get(API_URL + '/auftrag/getinfoauftragurl', this.AUTH_HEADER);
  }

  public getAuftragInforStoerungInhalt() {
    return forkJoin({
      stoergrund: this.http.get<string[]>(`${API_URL}/auftrag/stoergrunde`),
      stoerursache: this.getUniqueFeldFromTable('kaufus', 'Bezeichnung'),
      stoererfasser: this.getUniqueFeldFromTable('kauftr', 'StoerMeldender'),
    });
  }

  public sendAuftrag(auftrag: NewAuftragModel) {
    return this.http.post(API_URL + '/auftrag/add', auftrag, this.AUTH_HEADER_BIN);
  }

  public updateAuftrag(kauftrid: number, auftrag: any) {
    return this.http.post<MRproResponse>(API_URL + '/auftraege/' + kauftrid, auftrag, this.AUTH_HEADER);
  }

  public AuftragWFStatus(auftrag: any) {
    return this.http.post(API_URL + '/auftraege/WFStatus/', auftrag, this.AUTH_HEADER);
  }

  public sendNewMessdaten(formData: any) {
    return this.http.post<UploadResult>(API_URL + '/anlagen/add/messdatenfiles', formData, this.AUTH_HEADER);
  }

  public setAlternativeInstandsetzung(formData: any): Observable<any> {
    return this.http.post(API_URL + '/maengel/altinstandsetzungshinweis', formData, this.AUTH_HEADER);
  }

  public saveMangelBemerkung(req: any, id: number) {
    return this.http.post(API_URL + '/maengel/bemerkung/' + id, req, this.AUTH_HEADER);
  }

  public getMaengelEinheiten(): Observable<any> {
    return this.http.get(API_URL + '/maengel/mengeneinheiten', this.AUTH_HEADER);
  }

  public sendMultiRueckmeldung(maengel: any) {
    return this.http.post<MRproResponse>(API_URL + '/maengel/multirueckmeldung', maengel, this.AUTH_HEADER);
  }

  public sendRueckmeldungMangel(deltamangel: any) {
    return this.http.post(API_URL + '/anlagen/rueckmeldung/mangel', deltamangel, this.AUTH_HEADER);
  }

  public sendRueckmeldungMessung(deltamessung: any) {
    return this.http.post(API_URL + '/anlagen/rueckmeldung/messung', deltamessung, this.AUTH_HEADER);
  }

  public deleteFirma(id: number) {
    return this.http.delete(API_URL + '/anlagen/firmen/delete/' + id, this.AUTH_HEADER);
  }

  public deleteFormularName(id: number) {
    return this.http.delete(API_URL + '/formularname/delete/' + id, this.AUTH_HEADER);
  }

  public deleteFormular(id: number) {
    return this.http.delete(API_URL + '/formulare/delete/' + id, this.AUTH_HEADER);
  }

  public deleteTabelleName(id: number) {
    return this.http.delete(API_URL + '/tabelle/delete/' + id, this.AUTH_HEADER);
  }

  public deleteTabelle(id: number) {
    return this.http.delete(API_URL + '/tabellen/delete/' + id, this.AUTH_HEADER);
  }

  public deleteUser(id: number) {
    return this.http.delete(API_URL + '/users/delete/' + id, this.AUTH_HEADER);
  }

  public getmaxUser() {
    return this.http.get(API_URL + '/users/getmaxuser', this.AUTH_HEADER);
  }

  public deleteGroup(id: number) {
    return this.http.delete(API_URL + '/groups/delete/' + id, this.AUTH_HEADER);
  }

  public editFirmen(editarr: any) {
    return this.http.post(API_URL + '/anlagen/firmen/edit', editarr, this.AUTH_HEADER);
  }

  public editFormulare(editarr: any, vorlageID: number, tabelleIDUpdates: number[]): Observable<any> {
    const payload = { c: editarr, vorlageID, tabelleIDUpdates };
    return this.http.post(API_URL + '/formulare/edit', payload, this.AUTH_HEADER);
  }

  public addAnlageByFAT(
    data: any,
    vorlageID: any,
    gruppeid: number,
    ostammid: number,
    tabelleIDUpdates: any
  ): Observable<any> {
    const payload = { data, vorlageID, gruppeid, ostammid, tabelleIDUpdates };
    return this.http.post(API_URL + '/anlagen/add/fat', payload, this.AUTH_HEADER);
  }

  public addPruefungFAT(
    stamm: any,
    mess: any,
    bilder: any,
    info: any,
    ostammid: number,
    opruefid: number,
    vorlageid: any
  ): Observable<any> {
    const payload = {
      stamm,
      mess,
      bilder,
      info,
      ostammid,
      opruefid,
      vorlageid,
    };
    return this.http.post(API_URL + '/anlagen/add/fatpruefung', payload, this.AUTH_HEADER);
  }

  public addAnlageByFormular(data: any): Observable<any> {
    return this.http.post(API_URL + '/anlagen/add/form', data, this.AUTH_HEADER);
  }

  public editAnlagenDokumentKategorie(data: any): Observable<any> {
    return this.http.post(API_URL + '/anlagen/document/category', data, this.AUTH_HEADER);
  }

  public addAnlageDocument(data: any): Observable<any> {
    return this.http.post(API_URL + '/anlagen/documents', data, this.AUTH_HEADER);
  }

  public editSortTabellen(editarr: any) {
    return this.http.post(API_URL + '/formulare/edit', editarr, this.AUTH_HEADER);
  }

  public editTabellenFAT(editarr: any) {
    return this.http.post(API_URL + '/tabellen/editFAT', editarr, this.AUTH_HEADER);
  }

  public updateUser(editarr: any) {
    return this.http.post(API_URL + '/users/update', editarr, this.AUTH_HEADER);
  }

  public setPWini(items: any) {
    return this.http.post(API_URL + '/users/setpwini', items, this.AUTH_HEADER);
  }

  //#endregion
  //#region Anlage Basisdaten
  //#region stammdaten
  public getStammDaten(
    ostammid: number,
    otypid: number,
    typ_Line_Point: number,
    opruefid: number,
    istPrüfung: boolean,
    kpruvid: number
  ) {
    return this.isRep ?
        from(this.anlagenDB.GetStammDaten(ostammid, otypid, kpruvid, opruefid, istPrüfung))
      : this.http.get<MRproResponseInfo<StammDatenResponse>>(
          API_URL + `/stamm/${ostammid}/${otypid}/${typ_Line_Point}/${opruefid}/${istPrüfung}/${kpruvid}`,
          this.AUTH_HEADER
        );
  }

  public deletepruefungStammDaten(sendObj: { OSTAMMID: number; LPID: number; kprtypid: number }) {
    return this.http.post<MRproResponse>(API_URL + `/stamm/deletepruefung`, sendObj, this.AUTH_HEADER);
  }

  public archivStammDaten(sendObj: number[]) {
    return this.http.post<MRproResponse>(API_URL + `/stamm/archiv`, sendObj, this.AUTH_HEADER);
  }

  public deleteStammDaten(sendObj: number[]) {
    return this.http.post<MRproResponse>(API_URL + `/stamm/delete`, sendObj, this.AUTH_HEADER);
  }

  public copyStammDaten(ostammid: number, sendObj: { bezeichnung: string; otypid: number; typLinePoint: number }) {
    return this.http.post<MRproResponse>(API_URL + `/stamm/copy/${ostammid}`, sendObj, this.AUTH_HEADER);
  }

  public setStammDaten(ostammid: number, otypid: number, kpruvid: number, sendObj: StammDatenModel) {
    return this.isRep ?
        from(this.anlagenDB.SetStammDaten(ostammid, otypid, kpruvid, sendObj))
      : this.http.post<MRproResponseInfo<{ mediaStr: string; ostammid: number }>>(
          API_URL + `/stamm/${ostammid}/${otypid}/${kpruvid}`,
          sendObj,
          this.AUTH_HEADER
        );
  }

  public getSkizzenNames() {
    return httpResource<string[]>(() => `${API_URL}/skizzen/names`, { defaultValue: [] });
  }

  public getSkizzeByName(filename: string) {
    return this.isRep ?
        this.anlagenDB.GetSkizzeByName(filename)
      : firstValueFrom(this.http.get<string>(`${API_URL}/skizzen/${filename}`));
  }

  public saveSkizzeByName(filename: string, base64: string) {
    return this.isRep ?
        this.anlagenDB.SaveSkizzeByName(filename, base64)
      : firstValueFrom(this.http.put<void>(`${API_URL}/skizzen/${filename}`, { base64 }));
  }

  public setStammSkizze(ostammid: number, filename: string, base64: string) {
    return this.isRep ?
        from(this.anlagenDB.SetStamSkizze(ostammid, filename, base64))
      : this.http.post<MRproResponse>(API_URL + `/stamm/skizze/${ostammid}/${filename}`, { base64 }, this.AUTH_HEADER);
  }

  public getPassBilder(bildNames: string) {
    return this.isRep ?
        from(this.anlagenDB.GetPassBilder(bildNames))
      : this.http.post<FileForPreview[]>(API_URL + `/stamm/passbilder`, { bildNames }, this.AUTH_HEADER);
  }
  //#endregion
  //#region spezifikation
  public getSpezTemplates() {
    return this.isRep ?
        from(this.anlagenDB.GetSpezLinieTemplates())
      : this.http.get<Table>(API_URL + '/spez/templates', this.AUTH_HEADER);
  }

  public getSpez(ostammid: number, otypid: number, typid: number) {
    return this.isRep ?
        from(this.anlagenDB.GetSpezifikationen(ostammid, otypid, typid))
      : this.http.get<SpezPointType[] | { columns: SpezColumnType[]; rows: SpezRowType[] }>(
          API_URL + '/spez/' + ostammid + '/' + otypid + '/' + typid,
          this.AUTH_HEADER
        );
  }

  public setSpez(id: number, sendObj: SaveSpezifikationModel) {
    return this.isRep ?
        from(this.anlagenDB.SetSpezifikationen(id, sendObj))
      : this.http.post<MRproResponseInfo<SpezResponse>>(API_URL + '/spez/' + id, sendObj, this.AUTH_HEADER);
  }

  public deleteSpezAndHersteller(id: number) {
    return this.isRep ?
        from(this.anlagenDB.DeleteSpezifikation(id))
      : this.http.delete<MRproResponse>(API_URL + '/spez/' + id, this.AUTH_HEADER);
  }
  //#endregion
  //#region herstelldaten
  public getHerstelldaten(ospezid: number) {
    return this.http.get<HerstellDaten>(API_URL + `/hersteller/${ospezid}`, this.AUTH_HEADER);
  }

  public setHerstelldaten(ospezid: number, sendObj: HerstellDaten) {
    return this.http.post<MRproResponse>(API_URL + `/hersteller/${ospezid}`, sendObj, this.AUTH_HEADER);
  }
  //#endregion
  //#region natursschutz
  public getNaturschutzArten(otypid: number) {
    return this.isRep ?
        this.anlagenDB.GetNaturschutzArten(otypid)
      : firstValueFrom(this.http.get<string[]>(`${API_URL}/naturschutz/typen/${otypid}`));
  }
  public getNaturschutz(ostammid: number) {
    return this.isRep ?
        this.anlagenDB.GetNaturschutz(ostammid)
      : firstValueFrom(this.http.get<Table<NaturschutzRow>>(`${API_URL}/naturschutz/${ostammid}`));
  }

  public setNaturschutz(ostammid: number, sendObj: NaturschutzModel) {
    return this.isRep ?
        this.anlagenDB.SetNaturschutz(ostammid, sendObj)
      : firstValueFrom(
          this.http.post<MRproResponseInfo<{ id: number }>>(`${API_URL}/naturschutz/${ostammid}`, sendObj)
        );
  }
  public deleteNaturschutz(id: number) {
    return this.isRep ?
        this.anlagenDB.DeleteNaturschutz(id)
      : firstValueFrom(this.http.delete<MRproResponse>(`${API_URL}/naturschutz/${id}`));
  }
  //#endregion

  //#region Grundinstandsetzung
  public getGrundInstandTypen(otypid: number) {
    return this.isRep ?
        this.anlagenDB.GetGrundInstandArten(otypid)
      : firstValueFrom(this.http.get<string[]>(`${API_URL}/grundinstand/typen/${otypid}`));
  }
  public getGrundInstand(OPRUEFID: number, OSTAMMID: number, typ: number) {
    return this.isRep ?
        this.anlagenDB.GetGrundInstand(OPRUEFID, OSTAMMID)
      : firstValueFrom(this.http.get<Table<GIRow>>(`${API_URL}/grundinstand/${OPRUEFID}/${OSTAMMID}/${typ}`));
  }

  public setGrundInstand(sendObj: GIModel) {
    return this.isRep ?
        this.anlagenDB.SetGrundInstand(sendObj)
      : firstValueFrom(this.http.post<MRproResponseInfo<{ id: number }>>(`${API_URL}/grundinstand/`, sendObj));
  }
  //#endregion

  //#region ereignis
  public getEreignisTypen(otypid: number) {
    return this.http.get<string[]>(API_URL + '/ereignis/typen/' + otypid, this.AUTH_HEADER);
  }
  public getEreignis(ostammid: number) {
    return this.http.get<Table<EreignisRow>>(API_URL + '/ereignis/' + ostammid, this.AUTH_HEADER);
  }

  public setEreignis(ostammid: number, sendObj: EreignisModel) {
    return this.http.post<MRproResponseInfo<{ id: number }>>(
      API_URL + '/ereignis/' + ostammid,
      sendObj,
      this.AUTH_HEADER
    );
  }

  public deleteEreignis(id: number) {
    return this.http.delete<MRproResponse>(API_URL + `/ereignis/${id}`, this.AUTH_HEADER);
  }
  //#endregion
  //#region bauwerke
  public getBauwerksArten(otypid: number) {
    return this.isRep ?
        from(this.anlagenDB.GetBauwerksArten(otypid))
      : this.http.get<string[]>(API_URL + '/bauwerke/arten/' + otypid, this.AUTH_HEADER);
  }

  public getBauw(ostammid: number) {
    return this.isRep ?
        from(this.anlagenDB.GetBauwerke(ostammid))
      : this.http.get<Table<BauwerkRow>>(API_URL + '/bauwerke/' + ostammid, this.AUTH_HEADER);
  }

  public setBauw(ostammid: number, otypid: number, sendObj: BauwerkeModel) {
    return this.isRep ?
        from(this.anlagenDB.SetBauwerk(ostammid, sendObj))
      : this.http.post<MRproResponseInfo<{ id: number }>>(API_URL + '/bauwerke/' + ostammid + "/" + otypid, sendObj, this.AUTH_HEADER);
  }

  public getBauwerkeMediaAll(names: any) {
    return this.http.post<MRproResponseInfo<Media>>(API_URL + '/bauwerke/media/', names, this.AUTH_HEADER);
  }

  public deleteBauw(ostammid: number, id: number, typid: number) {
    return this.isRep ?
        from(this.anlagenDB.DeleteBauwerk(id))
      : this.http.delete<MRproResponse>(API_URL + `/bauwerke/${ostammid}/${id}/${typid}`, this.AUTH_HEADER);
  }
  //#endregion
  //#region BUE
  public getBUE(OPRUEFID: number) {
    return this.isRep ?
        from(this.anlagenDB.GetBUE(OPRUEFID))
      : this.http.get<BUE_Map>(`${API_URL}/bue/${OPRUEFID}`, this.AUTH_HEADER);
  }
  public getBUE_Bilder(OPRUEFID: number) {
    return this.isRep ?
        from(this.anlagenDB.GetBUE_Bilder(OPRUEFID))
      : this.http.get<string[]>(`${API_URL}/bue/${OPRUEFID}/bilder`, this.AUTH_HEADER);
  }
  public setBUE(id: number, quadrant: Key<QuadrantWert>, sendObj: BUE_Quadrant) {
    return this.isRep ?
        from(this.anlagenDB.SetBUE(id, quadrant, sendObj))
      : this.http.post<void>(`${API_URL}/bue/${id}/${quadrant}`, sendObj, this.AUTH_HEADER);
  }
  public setBUE_Bild(OPRUEFID: number, sendObj: { index: number; base64: string }) {
    return this.isRep ?
        from(this.anlagenDB.SetBUE_Bild(OPRUEFID, sendObj))
      : this.http.post<MRproResponse>(`${API_URL}/bue/${OPRUEFID}/bild`, sendObj, this.AUTH_HEADER);
  }
  public deleteBUE_Bild(OPRUEFID: number, index: number) {
    return this.isRep ?
        from(this.anlagenDB.DeleteBUE_Bild(OPRUEFID, index))
      : this.http.delete<MRproResponse>(`${API_URL}/bue/${OPRUEFID}/bild/${index}`, this.AUTH_HEADER);
  }
  public getBUEExcelTemplate(): Observable<any> {
    return this.http.get(API_URL + '/bue/excel', this.AUTH_HEADER);
  }
  //#endregion

  //#region Bauform
  public getAllKomponenten() {
    return firstValueFrom(this.http.get<Komponente[]>(`${API_URL}/komponente`));
  }

  public resortAlleBauformen() {
    return firstValueFrom(this.http.patch(`${API_URL}/bauform/resort/all`, null));
  }

  public getAllWerteListen() {
    return firstValueFrom(this.http.get<WerteListe[]>(`${API_URL}/bauform/wertelisten`));
  }

  public getBauformByOTYPID(otypid: number) {
    return firstValueFrom(this.http.get<Table<Bauform>>(`${API_URL}/bauform/${otypid}`));
  }

  public deleteBauform(id: number) {
    return firstValueFrom(this.http.delete(`${API_URL}/bauform/${id}`));
  }

  public saveBauform(otypid: number, sendObj: Partial<BauformModel>) {
    return firstValueFrom(this.http.post(`${API_URL}/bauform/${otypid}`, sendObj));
  }

  public resortBauform(sendObj: number[]) {
    return firstValueFrom(this.http.patch(`${API_URL}/bauform/resort`, sendObj));
  }
  //#endregion

  //#region Base-Items
  public getBaseItems(tabelle: 'SBAGP'): Promise<string[]>;
  public getBaseItems(tabelle: 'SBAGP', sub_name: string): Promise<SBAGP_Item[]>;
  public getBaseItems(tabelle: 'SWTYP'): Promise<Table<SWTYP_Item>>;
  public getBaseItems(tabelle: 'SBFEK'): Promise<Table<SBFEK_Item>>;
  public getBaseItems(tabelle: 'SSCHF'): Promise<Table<SSCHF_Item>>;
  public getBaseItems(tabelle: 'SGATT'): Promise<Table<SGATT_Item>>;
  public getBaseItems(tabelle: 'SBAUW'): Promise<Table<SBAUW_Item>>;
  public getBaseItems(tabelle: string): Promise<Table<BaseItem>>;
  public getBaseItems(tabelle: string, sub_id: number): Promise<Table<BaseItem>>;

  public getBaseItems(tabelle: string, sub_route: number | string = null) {
    return this.isRep ?
        this.baseItemsDB.GetBaseItems(tabelle, sub_route)
      : firstValueFrom(this.http.get(`${API_URL}/baseitems/${tabelle}/${sub_route ?? ''}`));
  }

  public getUniqueBaseItems(tabelle: string, sub_route: number = null) {
    return this.isRep ?
        this.baseItemsDB.GetSelectionFromTable(tabelle, sub_route)
      : firstValueFrom(this.http.get<string[]>(`${API_URL}/baseitems/${tabelle}/select`));
  }

  public renameBaugruppe(name: string, newName: string) {
    return this.isRep ?
        this.baseItemsDB.RenameBaugruppe(name, newName)
      : firstValueFrom(this.http.patch(`${API_URL}/baseitems/sbagp/${name}`, { name: newName }));
  }
  public setBaugruppe(name: string, sendObj: SBAGP_Item[]) {
    return this.isRep ?
        this.baseItemsDB.SetBaugruppe(name, sendObj)
      : firstValueFrom(this.http.post<void>(`${API_URL}/baseitems/sbagp/${name}`, sendObj));
  }
  public setBaseItems(tabelle: string, sendObj: BaseItem | SBFEK_Item, sub_route: number | string = null) {
    return this.isRep ?
        this.baseItemsDB.SetBaseItems(tabelle, sub_route, sendObj)
      : firstValueFrom(this.http.post<number>(`${API_URL}/baseitems/${tabelle}/${sub_route ?? ''}`, sendObj));
  }
  public deleteBaseItems(tabelle: string, idOrName: number | string) {
    return this.isRep ?
        Promise.reject('Löschen in Replikation ist gesperrt')
      : firstValueFrom(this.http.delete(`${API_URL}/baseitems/${tabelle}/${idOrName}`));
  }

  public getUniqueFeldFromTable(tabelle: string, field: string) {
    return this.http.get<string[]>(`${API_URL}/baseitems/common/${tabelle}/${field}`);
  }
  //#region Hilfe-Beschreibung
  public getHilfeBeschreibung(tabelle: HelperTabelle, id: number) {
    return this.isRep ?
        this.baseItemsDB.GetHelperBeschreibung(tabelle, id)
      : firstValueFrom(this.http.get<HilfeBeschreibung>(`${API_URL}/baseitems/helper/${tabelle}/${id}`));
  }

  public setHilfeBeschreibung(tabelle: HelperTabelle, id: number, sendObj: HilfeBeschreibung) {
    return this.isRep ?
        this.baseItemsDB.SetHelperBeschreibung(tabelle, id, sendObj)
      : firstValueFrom(this.http.post(`${API_URL}/baseitems/helper/${tabelle}/${id}`, sendObj));
  }
  //#endregion
  //#endregion

  //#region MangelBaum
  public getMangelBaum(otypid: number, joinedIds: string = '') {
    return this.isRep ?
        this.mangelBaumDB.LoadTree(otypid, joinedIds)
      : firstValueFrom(this.http.get<MangelBaumNode[]>(`${API_URL}/mangelbaum/${otypid}/${joinedIds}`));
  }

  public getMangelBaumEintrag(id: number) {
    return this.isRep ?
        this.mangelBaumDB.LoadEintrag(id)
      : firstValueFrom(this.http.get<MangelBaumNodeModel>(`${API_URL}/mangelbaum/eintrag/${id}`));
  }

  public getMangelBaumHistorie(idFn: () => number) {
    return rxResource({
      params: idFn,
      stream: ({ params: id }) => this.http.get<Table>(`${API_URL}/mangelbaum/historie/${id}`),
      defaultValue: TABLE_EMPTY(),
    });
  }

  public getMangelBaumInTable(otypidFn: () => number) {
    return rxResource({
      params: otypidFn,
      stream: ({ params: otypid }) => this.http.get<Table>(`${API_URL}/mangelbaum/table/${otypid}`),
      defaultValue: TABLE_EMPTY(),
    });
  }

  public setMangelBaumEintrag(otypid: number, sendObj: MangelBaumNodeModel) {
    return this.isRep ?
        this.mangelBaumDB.SaveEintrag(otypid, sendObj)
      : firstValueFrom(
          this.http.post<{ id: number; exist: boolean }>(`${API_URL}/mangelbaum/eintrag/${otypid}`, sendObj)
        );
  }

  public editMangelBaumField(szumzid: number, otypid:number, field: string, value: unknown) {
    return firstValueFrom(this.http.patch<unknown>(`${API_URL}/mangelbaum/edit/${szumzid}/${otypid}`, { field, value }));
  }

  public getMangelBaumSelect(otypidFn: () => number) {
    return resource({
      params: otypidFn,
      loader: ({ params: otypid }) =>
        this.isRep ?
          this.mangelBaumDB.LoadSelectWerten(otypid)
        : firstValueFrom(this.http.get<BaumSelect>(`${API_URL}/mangelbaum/select/${otypid}`)),
      defaultValue: EMPTY_SELECT,
    });
  }

  public deleteMangelBaumTree(id: number, joinedIds: string = '') {
    return firstValueFrom(this.http.delete(`${API_URL}/mangelbaum/${id}/${joinedIds}`));
  }

  public getMangelBaumUsed() {
    return resource({
      loader: () =>
        this.isRep ?
          this.mangelBaumDB.GetUsedUniqueSelection()
        : firstValueFrom(this.http.get<BaumSelectUsed>(`${API_URL}/mangelbaum/select-used`)),
      defaultValue: EMPTY_USED_SELECT,
    });
  }
  //#endregion

  //#region MangelErfassung
  /*
  public getMangelBaumAll(otypidFn: () => number) {
    return resource({
      params: otypidFn,
      loader: ({ params: otypid }) =>
        this.isRep ?
          this.mangelBaumDB.GetMangelBaumAll(otypid)
        : firstValueFrom(this.http.get<MangelBaumNodeModel[]>(`${API_URL}/mangelbaum/all/${otypid}`)),
    });
  }
  */

  public getOrCreateInspektion(params: {
    OSTAMMID: number;
    OPRUEFID: number;
    OTYPID: number;
    KPRUVID: number;
    typ_Line_Point: number;
    isEdit: boolean;
  }) {
    return this.isRep ?
        this.mangelDB.GetOrCreateInspektion(params)
      : firstValueFrom(
          this.http.get<{ OPRUEFID: number; isMessungDrehen: boolean; Datum: string }>(`${API_URL}/inspektion`, {
            params,
          })
        );
  }

  public saveInspektionsDetails(sendObj: {
    OPRUEFID: number;
    OSTAMMID: number;
    KPRUVID: number;
    P_Datum: string;
    M_Mess_Drehen: boolean;
  }) {
    return this.isRep ?
        this.mangelDB.SaveInspektionsDetails(sendObj)
      : firstValueFrom(this.http.patch(`${API_URL}/inspektion`, sendObj));
  }

  public setInspektionsDelStatus(sendObj: { OPRUEFID: number; OSTAMMID: number; KPRUVID: number }) {
    return this.isRep ?
        this.mangelDB.SetInspektionsDelStatus(sendObj)
      : firstValueFrom(this.http.patch(`${API_URL}/inspektion/delstatus`, sendObj));
  }

  public getMaengelInInspektion(
    paramsFn: () => {
      OPRUEFID: number;
      OSTAMMID: number;
      OTYPID: number;
      typ_Line_Point: number;
    }
  ) {
    return resource({
      params: () => paramsFn()?.OPRUEFID && paramsFn(),
      loader: ({ params }) =>
        this.isRep ?
          this.mangelDB.GetMaengelInInspektion(params)
        : firstValueFrom(this.http.get<Table<MangelRowType>>(`${API_URL}/mangel`, { params })),
      defaultValue: TABLE_EMPTY(),
    });
  }

  public sendNewMangel(mangel: MangelModel, files: FileObject[] = []) {
    return this.isRep ?
        this.mangelDB.SaveMangelToHistorie(mangel, files)
      : firstValueFrom(this.http.post<Row>(`${API_URL}/mangel`, { mangel, files }, { params: { mode: 'historie' } }));
  }

  public updateMangel(mangel: MangelModel, files: FileObject[], savedFiles: string) {
    return this.isRep ?
        this.mangelDB.UpdateMangel(mangel, files, savedFiles)
      : firstValueFrom(
          this.http.post<{ OMAZSID: number; table: Table<MangelRowType> }>(
            `${API_URL}/mangel`,
            {
              mangel,
              files,
              savedFiles,
            },
            { params: { mode: 'inspektion' } }
          )
        );
  }

  public updateMangelLfNr(omazsid: number, lfNr: number) {
    return this.isRep ?
        this.mangelDB.UpdateLfNr(omazsid, lfNr)
      : firstValueFrom(this.http.patch(`${API_URL}/mangel/lfNr/${omazsid}`, lfNr));
  }

  public updateMangelStatus(omazsid: number) {
    return this.isRep ?
        this.mangelDB.UpdateStatus(omazsid)
      : firstValueFrom(this.http.patch(`${API_URL}/mangel/status/${omazsid}`, null));
  }

  public updateMangelSZUMZID(omazsid: number, szumzid: number) {
    return this.isRep ?
        this.mangelDB.UpdateSZUMZID(omazsid, szumzid)
      : firstValueFrom(this.http.patch<unknown>(`${API_URL}/mangel/szumzid/${omazsid}`, szumzid));
  }

  public updateMangelAuftrag(omazsid: number, auftragId: number, kauftsId?: number) {
    return firstValueFrom(this.http.patch<unknown>(`${API_URL}/mangel/auftrag/${omazsid}`, { auftragId, kauftsId }));
  }

  public updateMangelToEmpty(sendObj: {
    OTYPID: number;
    OSTAMMID: number;
    OPRUEFID: number;
    typ_Line_Point: number;
    OMAZSIDs: number[];
  }) {
    return this.isRep ?
        this.mangelDB.UpdateToEmpty(sendObj)
      : firstValueFrom(this.http.patch<Table<MangelRowType>>(`${API_URL}/mangel/empty`, sendObj));
  }

  public updateInspektionToChecklist(sendObj: {
    OTYPID: number;
    OSTAMMID: number;
    OPRUEFID: number;
    typ_Line_Point: number;
    Titel: string;
    maengel?: MangelRowModel[];
  }) {
    return this.isRep ?
        this.mangelDB.UpdateToChecklist(sendObj)
      : firstValueFrom(this.http.patch<Table<MangelRowType>>(`${API_URL}/inspektion/checklist`, sendObj));
  }

  public deleteMangel(...omazsid: number[]) {
    return this.isRep ?
        this.mangelDB.DeleteMangel(omazsid)
      : firstValueFrom(this.http.delete(`${API_URL}/mangel`, { params: { omazsid } }));
  }

  public deleteMangelAusAuftrag(...omazsid: number[]) {
    return firstValueFrom(this.http.delete<boolean>(`${API_URL}/mangel/auftrag`, { params: { omazsid } }));
  }

  public getChecklistTitels(otypidFn: () => number) {
    return resource({
      params: otypidFn,
      loader: ({ params: otypid }) =>
        this.isRep ?
          this.mangelDB.GetChecklistenTitels(otypid)
        : firstValueFrom(this.http.get<string[]>(`${API_URL}/checklist/titel/${otypid}`)),
    });
  }

  public saveChecklist(titel: string, otypid: number, items: BaseItem[]) {
    return this.isRep ?
        this.mangelDB.SaveChecklist(titel, otypid, items)
      : firstValueFrom(this.http.put(`${API_URL}/checklist/${titel}/${otypid}`, items));
  }

  public getGeoForPosition(ostammidFn: () => number) {
    return resource({
      params: ostammidFn,
      loader: ({ params: ostammid }) =>
        this.isRep ?
          this.anlagenDB.GetGeo(ostammid)
        : firstValueFrom(this.http.get<Position[]>(`${API_URL}/mangel/geo/${ostammid}`)),
    });
  }

  public getBauartgruppe(ostammidFn: () => number) {
    return resource({
      params: ostammidFn,
      loader: ({ params: ostammid }) =>
        this.isRep ?
          this.anlagenDB.GetBauartGruppe(ostammid)
        : firstValueFrom(this.http.get<Record<string, number>>(`${API_URL}/mangel/bauartgruppe/${ostammid}`)),
    });
  }

  public getSpezForStamm(ostammidFn: () => number) {
    return resource({
      params: ostammidFn,
      loader: ({ params: ostammid }) =>
        this.isRep ?
          this.anlagenDB.GetSpezForStamm(ostammid)
        : firstValueFrom(this.http.get<SpezRow[]>(`${API_URL}/mangel/spez/${ostammid}`)),
      defaultValue: [],
    });
  }
  //#endregion
  //#region Einstellungen

  public getTypOption<K extends Key<SYSOOPT>>(otypidFn: () => number, option: K) {
    const resource = this.getTypOptions(otypidFn, option);
    return computed(() => (resource.hasValue() ? resource.value()[option] : undefined));
  }

  public getTypOptions<K extends Key<SYSOOPT>>(otypidFn: () => number, ...options: K[]): ResourceRef<Pick<SYSOOPT, K>> {
    return resource({
      params: otypidFn,
      loader: ({ params: otypid }) =>
        this.isRep ?
          this.einstellungenDB.GetTypOptions(otypid, ...options)
        : firstValueFrom(
            this.http.get<Pick<SYSOOPT, K>>(`${API_URL}/settings/sysoopt/${otypid}`, { params: { options } })
          ),
      defaultValue: {} as Pick<SYSOOPT, K>,
    });
  }
  public getOptions<K extends Key<SYSINI>>(...options: K[]): ResourceRef<Pick<SYSINI, K>> {
    return resource({
      loader: () =>
        this.isRep ?
          this.einstellungenDB.GetOptions(...options)
        : firstValueFrom(this.http.get<Pick<SYSINI, K>>(`${API_URL}/settings/sysini`, { params: { options } })),
      defaultValue: {} as Pick<SYSINI, K>,
    });
  }

  public getInterfaceOptions<K extends Key<KINTERF>>(...options: K[]): ResourceRef<Pick<KINTERF, K>> {
    return resource({
      loader: () =>
        this.isRep ?
          this.einstellungenDB.GetInterfaceOptions(...options)
        : firstValueFrom(this.http.get<Pick<KINTERF, K>>(`${API_URL}/settings/kinterf`, { params: { options } })),
      defaultValue: {} as Pick<KINTERF, K>,
    });
  }

  public getRangeFK() {
    const options = this.getOptions('optMINNumFK', 'optMAXNumFK');
    return computed(() => {
      if (!options.hasValue()) return [];
      const { optMINNumFK: min, optMAXNumFK: max } = options.value();
      return Array.from({ length: max - min + 1 }, (_, i) => min + i);
    });
  }
  //#endregion

  //#region Abnahme
  public getAbnahme(id: number) {
    return this.http.get<AbnahmeDetailResponse>(`${API_URL}/abnahme/${id}`);
  }

  public getAbnahmeMangel(omazsid: number) {
    return this.http.get<AbnahmeMangel>(`${API_URL}/abnahme/mangel/${omazsid}`);
  }

  public saveAbnahme(request: AbnahmeSaveRequest) {
    return this.http.post<AbnahmeSaveResponse>(`${API_URL}/abnahme`, request);
  }

  public saveAbnahmeFiles(abnahmeId: number, request: AbnahmeSaveFilesRequest) {
    return this.http.post<AbnahmeSaveFilesResponse>(`${API_URL}/abnahme/${abnahmeId}/files`, request);
  }

  public getAbnahmeLargeFile(id: number) {
    return this.http.get<string>(`${API_URL}/abnahme/file/${id}`);
  }

  public getAbnahmen(auftragid: number) {
    return this.http.get<Table>(`${API_URL}/abnahme/all/${auftragid}`);
  }

  public getAbnahmenProtokolls(auftragid: number) {
    return this.http.get<AbnahmeProtokollSummary[]>(`${API_URL}/abnahme/${auftragid}/protokolls`);
  }

  public getAbnahmeProtokoll(id: number) {
    const language = localStorage.getItem('language') || 'de';
    return this.http.get<string>(`${API_URL}/abnahme/${id}/protokoll?language=${encodeURIComponent(language)}`);
  }
  //#endregion
  //#region generic GET & POST
  public requestHead(url: string) {
    if (!url.startsWith('/')) url = '/' + url;
    return this.http.head(API_URL + url, this.AUTH_HEADER);
  }

  public requestGET<T = any>(url: string): Observable<T> {
    if (!url.startsWith('/')) url = '/' + url;
    return this.http.get<T>(API_URL + url, this.AUTH_HEADER);
  }

  public requestPOST(url: string, req: any): Observable<any> {
    if (!url.startsWith('/')) url = '/' + url;
    return this.http.post(API_URL + url, req, this.AUTH_HEADER);
  }

  public beacon(url: string, req: any) {
    if (!url.startsWith('/')) url = '/' + url;

    const body = new Blob([JSON.stringify(req)], {
      type: 'application/json;charset=UTF-8',
    });
    this.document.defaultView.navigator.sendBeacon(API_URL + url, body);
  }
  //#endregion

  //#region other helpers
  public getImage(path: string) {
    if (path !== undefined && path !== null) {
      if (path.indexOf('undefined') == -1) {
        return this.http
          .get(API_URL + path, {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('jwt')),
            responseType: 'blob',
          })
          .pipe(
            catchError((err: any, caught: Observable<any>): ObservableInput<any> => {
              if (err.status == 404) return this.img_placeholder;
              return throwError(() => err);
            })
          )
          .pipe(
            map(e => {
              if (typeof e == 'string' && e.indexOf('placeholder') != -1) return e;
              return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e));
            })
          );
      }
    }
    return this.img_placeholder;
  }

  private handleError(error: Response | any) {
    console.error('ApiService::handleError', error);
    return throwError(() => error);
  }

  public refreshJWT() {
    this.isRep = IsRep();
    const jwt = localStorage.getItem('jwt');
    if (!jwt) return;

    this.AUTH.Bearer = `Bearer ${jwt}`;
    // HttpHeaders is immutable - .set() returns a new object, so we must reassign
    this.AUTH_HEADER.headers = this.AUTH_HEADER.headers.set('Authorization', `Bearer ${jwt}`);
    this.AUTH_HEADER_NO_CACHE.headers = this.AUTH_HEADER_NO_CACHE.headers.set('Authorization', `Bearer ${jwt}`);
    this.AUTH_HEADER_BIN.headers = this.AUTH_HEADER_BIN.headers.set('Authorization', `Bearer ${jwt}`);
    this.AUTH_HEADER_ARR.headers = this.AUTH_HEADER_ARR.headers.set('Authorization', `Bearer ${jwt}`);
    this.AUTH_HEADER_OBSERVE.headers = this.AUTH_HEADER_OBSERVE.headers.set('Authorization', `Bearer ${jwt}`);
  }

  public convertFileAsBlob = function b64toBlob(b64Data, name, sliceSize = 512) {
    let t = name.split('.').pop();
    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.codePointAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: 'application/' + t });
    return blob;
  };

  public downloadBlobAsFile = function (data, filename) {
    const contentType = data.type || 'application/octet-stream';
    if (!data) {
      console.error(' No data');
      return;
    }

    var blob = new Blob([data], { type: contentType }),
      e = document.createEvent('MouseEvents'),
      a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = [contentType, a.download, a.href].join(':');
    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  };

  public logError(errorPayload: ErrorPayload): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('jwt'),
      'Content-Type': 'application/json',
    });
    return this.http.post(API_URL + '/log/error', errorPayload, { headers }).pipe(
      catchError((error: any) => {
        console.error('Logging error failed:', error);
        return throwError(() => error);
      })
    );
  }

  public logAuthError(errorPayload: ErrorPayload): Observable<any> {
    return this.http.post(API_URL + '/log/auth-error', errorPayload, this.AUTH_HEADER_LOGIN_NO_CACHE).pipe(
      catchError((error: any) => {
        console.error('Anonymous auth logging failed:', error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
}

export async function zipAuspacken<T>(data: ArrayBuffer): Promise<T> {
  const jsZip: JSZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();

  const zip = await jsZip.loadAsync(data);
  const jsonMangel = await zip.file('tmp.txt').async('string');
  return JSON.parse(jsonMangel) as T;
}
